<template>
<div id="popup">
    <!--미가입 고객 회원가입 팝업 -->
    <div v-if="popup_code==3" id="alert_layer">
        <div class="join_member_wrap">
            <div class="join_member_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>미가입 고객입니다.<br />회원가입하시겠습니까?</span>
                    </div>
                </div>
                <div class="alert-footer join_member_footer">
                    <div @click="modal_close" class="btn_close alert-btn-close">닫기</div>
                    <div @click="modal_close" class="btn_ok alert-btn-close">확인</div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 이용종료 팝업 -->
    <div v-if="popup_code==4" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico04.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>이용을 종료하시겠습니까?</span><br>
                        <span>남은시간 : data</span><br>
                        <span>종료날짜 : data</span>
                    </div>
                </div>
                <div class="end_of_footer">
                    <div @click="modal_close" class="btn_close">닫기</div>
                    <div @click="modal_close" class="btn_ok">확인</div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
    <!-- 좌석이동 팝업 -->
    <div v-if="popup_code==5" id="alert_layer">
        <div class="seat_check_wrap">
            <div class="seat_check_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>{{move_seat_name}}번 좌석으로<br> 이동하시겠습니까 ?</span>
                    </div>

                </div>
                <div class="seat_check_footer">
                    <div @click="modal_close" class="btn_close">닫기</div>
                    <div @click="move_seat" class="btn_ok">확인</div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!--좌석이동불가 팝업-->
    <div v-if="popup_code==6" id="alert_layer">
        <div class="seat_nomove_wrap">
            <div class="seat_nomove_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body wordcorrect">
                        <span>고정석은 좌석 종료가 불가능합니다.<br> 퇴실 문자를 발송하시겠습니까 ?<br>확인 버튼을 누르면 문자가 전송됩니다.</span>
                    </div>
                    <div class="seat_nomove_footer">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <div @click="parents_sms_send" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 이용종료 팝업 -->
    <div v-if="popup_code==7" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>이용을 종료하시겠습니까?</span>
                        <ul class="close_time">
                            <li class="tit">남은시간 </li>
                            <li>{{seat_left_time}}</li>
                            <template v-if="time_goods_flag == 0">
                            <li class="tit">종료날짜 </li>
                            <li>{{seat_use_end_time}}</li>
                            </template>
                            <template v-else>
                            <li class="tit">만료기간 </li>
                            <li>{{seat_expire_time}}</li>
                            </template>
                        </ul>
                    </div>
                </div> 
                <div class="end_of_footer">
                    <div @click.once="modal_close" class="btn_close">닫기</div>
                    <div @click="seat_use_end" class="btn_ok">확인</div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 입실문자 팝업 -->
    <div v-if="popup_code==8" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop send_message_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>입실 문자를 발송하시겠습니까? <br>확인 버튼을 누르면 문자가 발송됩니다.</span>
                    </div>
                    <div class="end_of_footer">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <div @click="modal_close" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 이미사용중인 좌석 팝업 -->
    <div v-if="popup_code==9" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop already_seat_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico04.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>이미 사용중인 좌석입니다.</span>
                        <p>종료예상시간 : data</p>
                    </div>
                </div>
                <div class="end_of_footer one_btn_footer">
                    <div @click="modal_close" class="btn_close_center">닫기</div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 이미사용중인 사물함 팝업 -->
    <div v-if="popup_code==10" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop already_locker_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico04.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>이미 사용중인 사물함 입니다.</span>
                    </div>

                </div>
                <div class="end_of_footer one_btn_footer">
                    <div @click="modal_close" class="btn_close_center">닫기</div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 좌석 이용종류 팝업 -->
    <div v-if="popup_code==11" id="alert_layer">
        <div class="type_of_use_wrap">
            <div class="type_of_use_pop">
                <div class="alert-container2">
                    <div class="alert-head">
                        <p class="pop_tit">내 좌석</p>
                    </div>
                    <div class="alert-body alert-body2 hidden-scroll">
                        <div class="tab_contents pop_tab">
                            <div class="tit01"><img src="../../assets/image/use_pop_icon1.png"><div class='img-title'>내 좌석 정보</div></div>

                            <div class="info_box" style="overflow:auto;">
                                <ul class="list_03" v-for="(item,index) in seat_info" :key="index">
                                    <li>
                                        <div class="info_title">좌석</div>
                                        <div class="into_data">{{item.seat_name}}번</div>
                                    </li>
                                    <li>
                                        <div class="info_title">시작시간</div>
                                        <div class="into_data">{{item.use_start_datetime}}</div>
                                    </li>
                                    <li>
                                        <div class="info_title">종료시간</div>
                                        <div class="into_data">{{item.use_end_datetime}}</div>
                                    </li>
                                </ul>
                                <div  v-if="continue_seat_purchase_history_flag">
                                    <ul class="list_03" v-for="(item,index) in seat_info" :key="index" style="position:relative;">
                                        <li>
                                            <div class="info_title">연장상품명</div>
                                            <div class="into_data">{{useinfo_exten_seat_item_name}}</div>
                                        </li>
                                        <li v-if="already_exten_seat_item_time > 0">
                                            <div class="info_title">연장 시간계획 </div>
                                            <div class="into_data">{{useinfo_exten_seat_use_our_plan}}</div>
                                        </li>
                                        <li v-if="already_exten_seat_item_time == 0 || already_exten_seat_item_time < 0"></li>
                                        <li>
                                            <div class="info_title">연장시작시간 </div>
                                            <div class="into_data">{{item.use_end_datetime}}</div>
                                        </li>
                                        <li>
                                            <div class="info_title">종료시간 </div>
                                            <div class="into_data">{{useinfo_exten_seat_item_time}}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!--
                            <div class="tit01 mt15"><img src="../../assets/image/use_pop_icon2.png"><div class='img-title'>내 상품 &amp; 내 쿠폰</div></div>
                            <div class="info_box">
                                <ul class="list_03">
                                    <li>
                                        <div class="info_title">내 상품</div>
                                        <div class="into_data">{{my_seat_product_list.length}} 개</div>
                                    </li>
                                    <li>
                                        <div class="info_title">내 쿠폰</div>
                                        <div class="into_data"> {{my_coupon_list.length}} 개</div>
                                    </li>
                                </ul>
                            </div>
                            -->
                            <div class="used-btn-area">
                                    <ul class="fixedd">
                                        <template v-if="continue_seat_purchase_history_flag && !this.time_continue_flag">
                                            <li @click="move_payment_seat_sub()">
                                                <img src="../../assets/image/seat_ex_change.png"><div>이용연장<br>상품변경</div>
                                            </li>
                                        </template> 
                                        <template v-if="!continue_seat_purchase_history_flag && !this.time_continue_flag">
                                            <li @click="move_payment_seat_sub()">
                                                <img src="../../assets/image/seat_ex.png"><div>이용연장</div>
                                            </li>
                                        </template>

                                        <li @click="open_seatMap" v-if="!this.seat_move_flag"> 
                                            <img src="../../assets/image/seat-move.png"><div>자리이동</div>
                                        </li>
                                        <li @click="askFor_seat_use_end()">
                                            <img src="../../assets/image/seat-end.png"><div>이용종료</div>
                                        </li>
                                    </ul>
                            </div>
                        </div>
                    </div>

                    <div class="type_of_use_footer one_btn">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <!-- <div @click="move_seat" class="btn_ok">확인</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 사물함 이용종류 팝업 -->
    <div v-if="popup_code==12" id="alert_layer">
        <div class="using_kind_wrap">
            <div class="using_kind_pop locker_using_kind_pop">
                <div class="alert-container2">
                    <div class="alert-head">
                        <!-- <div class="alert-icon">
                            <img src="../../assets/image/pop_ico06.png">
                        </div> -->
                        <p class="pop_tit">
                            내 사물함
                        </p>
                    </div>
                    <div class="alert-body alert-body2 hidden-scroll">
                        <div class="tab_contents pop_tab">
                            <div class="tit01"><img src="../../assets/image/use_pop_icon1.png"><div class='img-title'>내 사물함 정보</div></div>
                            <div class="info_box">
                                <ul class="list_03" v-for="(item,index) in locker_info" :key="index">
                                    <li>
                                        <div class="info_title">{{item.locker_name}}번 사물함</div>
                                    </li>
                                    <li>
                                        <div class="info_title">상품 </div>
                                        <div class="into_data">{{item.product_day}}일</div>
                                    </li>
                                    <li>
                                        <div class="info_title">시작시간 </div>
                                        <div class="into_data">{{convertDate(item.start_datetime)}} {{convertTime(item.start_datetime)}}</div>
                                    </li>
                                    <li>
                                        <div class="info_title">종료시간 </div>
                                        <div class="into_data">{{convertDate(item.end_datetime)}} {{convertTime(item.end_datetime)}}</div>
                                    </li>
                                </ul>
                            </div>
                            <br>
                            <div class="used-btn-area" v-if="!exten_locker_flag">
                                <ul class="fixedd">
                                    <li @click="locker_using_chkbox(0)">
                                        <img src="../../assets/image/seat_ex.png"><div>이용연장</div>
                                    </li>
                                </ul>
                                <!-- <input type="checkbox" class="checks" id="agrre_yn01" name="agrre_yn_locker" @click="locker_using_chkbox(0)">
                                <label for="agrre_yn01">이용연장</label> -->
                                <!-- 사물함 자리이동 주석처리 -->
                                <!-- <input type="checkbox" class="checks" id="agrre_yn03" name="agrre_yn_locker" @click="locker_using_chkbox(1)">
                                <label for="agrre_yn03">자리이동</label> -->
                            </div>

                            <br>
                            <br>
                        </div>
                    </div>

                    <div class="type_of_use_footer one_btn">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <!-- <div @click="move_seat" class="btn_ok">확인</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 사물함 이동확인 팝업 -->
    <div v-if="popup_code==13" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>{{move_locker_name}} 번 사물함으로 </span> <br>
                        <span>이동하시겠습니까? </span>
                    </div>
                    <div class="end_of_footer">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <div @click="move_locker" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 빈 사물함 팝업 -->
    <div v-if="popup_code==14" id="alert_layer">
        <div class="door_print_wrap">
            <div class="door_print_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico04.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>빈 사물함을 선택해 주세요. </span> <br>
                    </div>
                    <div class="door_print_footer">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <div @click="modal_close" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 그룹룸 이용종류 팝업 -->
    <div v-if="popup_code==15" id="alert_layer">
        <div class="type_of_use_wrap">
            <div class="type_of_use_groom_pop">
                <div class="alert-container2">
                    <div class="alert-head">
                        <p class="pop_tit"><span class="tit_img"></span>이용종류</p>
                    </div>
                    <div class="alert-body alert-body2">
                        <div class="tab_contents pop_tab">
                            <div class="tit01"><img src="../../assets/image/use_pop_icon1.png"><div class='img-title'>내 그룹룸 정보</div></div>
                            <div class="info_box">
                                <ul class="list_03" v-for="(item,index) in groom_info" :key="index">
                                    <li><div class="info_title">좌석 </div>
                                        <div class="into_data">{{item.groom_name}}</div>
                                    </li>
                                    <li><div class="info_title">상태 </div>
                                        <div class="into_data">사용중</div>
                                    </li>
                                    <li><div class="info_title">시작시간 </div>
                                        <div class="into_data">{{item.use_start_datetime}}</div>
                                    </li>
                                    <li><div class="info_title">종료시간 </div>
                                        <div class="into_data">{{item.use_end_datetime}}</div>
                                    </li>
                                    <li class="ex-li" v-if="extention_groom_flag == true && item.continue_yn == 1">
                                        <div class="info_title">연장 종료시간 : </div>
                                        <div class="into_data">{{exten_groom_use_end_datetime}}</div>
                                    </li>
                                </ul>
                            </div>
                            <!-- 현재 popup_code 15와 20이 같은 쿼리를 조회하도록 되어있는데, 하나의 상품으로
                             여러 그룹룸을 이용시작하는걸 막고자 사용중인 상품은 쿼리에 조회되지 않도록 조건을 걸어놨다.
                             따라서 내 상품목록에도 사용중인 상품이 조회되지 않기때문에 주석처리함 2020.07.13 YJH -->
                            <!--  <div class="tit01">내 상품목록</div>
                          <table class="table03_a">
                              <colgroup>
                                  <col width="15%" />
                                  <col width="15%" />
                                  <col width="15%" />
                                  <col width="30%" />
                                  <col width="25%" />
                              </colgroup>
                              <thead>
                                  <tr>
                                      <th>이용상품</th>
                                      <th>이용시간</th>
                                      <th>이용상태</th>
                                      <th>사용기간</th>
                                      <th>남은시간</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for=" (item , index) in my_groom_product_list" :key="index">
                                      <td>{{item.goods_group_name}}</td>
                                      <td>{{item.goods_time}}</td>
                                      <td>{{item.name}}</td>
                                      <td>{{item.use_end_datetime}}</td>
                                      <td>{{item.str_left_time}}</td>
                                  </tr>
                              </tbody>
                          </table> -->
                            <div class="used-btn-area" v-if="!extention_groom_flag">
                                    <ul class="fixedd">

                                        <li @click="move_payment_groom">
                                            <img src="../../assets/image/seat_ex.png"><div>이용연장</div>
                                        </li>
                                        <li @click="askFor_groom_use_end" v-if="!reservation_groom_flag">
                                            <img src="../../assets/image/seat-end.png"><div>이용종료</div>
                                        </li>
                                    </ul>
                                    <!-- <template v-if="!extention_groom_flag">
                                        <input type="checkbox" class="checks" id="agrre_01" name="agrre_yn" @click="move_payment_groom">
                                        <label for="agrre_01">이용연장</label>
                                    </template>
                                    <template v-if="!extention_groom_flag">
                                        <input type="checkbox" class="checks" id="agrre_02" name="agrre_yn" @click="askFor_groom_use_end">
                                        <label for="agrre_02">이용종료</label>
                                    </template>
                                    <input type="checkbox" class="checks" id="agrre_03" name="agrre_yn" @click="groom_barcode_view()">
                                    <label for="agrre_03">출입증보기</label> -->

                            </div>
                        </div>
                    </div>
                    <!-- <div class="alert-body">
                        <div v-if="seat_flag">

                        </div>
                    </div> -->
                    <div class="type_of_use_footer">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <div @click="modal_close" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 좌석이동 불가 팝업 -->
    <div v-if="popup_code==16" id="alert_layer">
        <div class="join_member_wrap">
            <div class="join_member_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico04.png">
                        </div>
                    </div>
                    <div class="alert-body wordcorrect">
                        <span>해당 좌석으로 이동이 불가능합니다. </span> <br>
                    </div>
                </div>
            </div>
            <div class="join_member_footer">
                <div @click="modal_close" class="btn_close">닫기</div>
                <div @click="modal_close" class="btn_ok">확인</div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 그룹룸 예약 결제 팝업 -->
    <div v-if="popup_code==17" id="alert_layer" class="alert-layer">
        <div class="end_of_wrap">
            <div class="end_of_pop groom_pay_reserve_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico04.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>그룹룸 예약 결제 </span> <br>

                    </div>
                    <div class="end_of_footer">
                        <div @click="modal_close" class="btn_close">다음에 결제</div>
                        <div @click="modal_close" class="btn_ok">지금 결제</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- 좌석상품 사용 되물음 팝업 -->
    <div v-if="popup_code==18" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body wordcorrect">
                        <span>해당 상품의 이용만료일수는 {{ extention_data[0].end_date}} 입니다.<br>
                            사용하시겠습니까 ?</span>
                    </div>
                    <div class="end_of_footer">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <div @click="product_use_ok" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 좌석상품 구매할때 내상품, 내쿠폰목록 지도 -->
    <div v-if="popup_code==19" id="alert_layer">
        <div class="using_kind_wrap">
            <div class="using_kind_pop pay_product_list_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <p  class="pop_tit" v-if="seat_use_txt_flag">좌석 연장점유</p>
                        <p  class="pop_tit" v-if="!seat_use_txt_flag">좌석 점유</p>
                    </div>
                    <div class="alert-body alert-body2 hidden-scroll">
                        <div class="tab_contents pop_tab">
                            <p class="tit01">내 상품목록</p>
                            <div class="myproduct_wrap">
                                <template v-if="my_seat_product_list.length == 0">
                                    <div class="myproduct">
                                        <ul>
                                            <li>
                                                <div style="font-size: .85rem;">이용가능한 상품이 없습니다.</div>
                                            </li>
                                        </ul>
                                    </div>
                                </template>

                                <template v-if="!extention_flag">
                                    <!-- 이게1묶음  -->
                                    <template>
                                        <swiper ref="awesomeSwiperA" class="swiper" :options="swiperOption">
                                            <template v-for="(item, index) in my_seat_product_list">
                                                <template v-if="item.show_chk != true">
                                                    <div class="swiper-slide myproduct"  :key="'my_seat_product_tr'+index">
                                                        <ul class="list_03 myproduct_list">
                                                            <li>
                                                                <div class="info_title">이용상품</div>
                                                                <div class="into_data">{{item.goods_group_name}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title">이용시간</div>
                                                                <div class="into_data">{{item.goods_time}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title">남은시간</div>
                                                                <div class="into_data">{{item.str_left_time}}</div>
                                                            </li>
                                                            <li>
                                                                <div v-if="item.name != '사용전'" class="info_title color1">{{item.name}}</div>
                                                                <div v-if="item.name == '사용전'" class="info_title color2">{{item.name}}</div>
                                                                <div class="myproduct_select_btn" v-if="item.use_time_settings_yn != 1" @click="goods_use_click(index, 'goods')">선 택</div>
                                                                <div class="myproduct_select_btn" v-if="item.use_time_settings_yn == 1" @click="use_time_setting(item,index,'goods')">선 택</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </template>
                                            <div class="swiper-pagination" slot="pagination"></div>
                                        </swiper>

                                    </template>

                                    <!-- 이게1묶음  -->
                                </template>

                                <template v-if="extention_flag">
                                    <template>
                                        <swiper ref="awesomeSwiperA" class="swiper" :options="swiperOption">
                                            <!-- 이게1묶음  -->
                                            <template v-for="(item, index) in my_seat_product_list">
                                                <template v-if="item.time_zone_yn != 1 && item.show_chk != true">
                                                    <div class="swiper-slide myproduct" :key="'my_seat_product_tr'+index">
                                                        <ul class="list_03 myproduct_list">
                                                            <li>
                                                                <div class="info_title">이용상품</div>
                                                                <div class="into_data">{{item.goods_group_name}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title">이용시간</div>
                                                                <div class="into_data">{{item.goods_time}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title">남은시간</div>
                                                                <div class="into_data">{{item.str_left_time}}</div>
                                                            </li>
                                                            <li>
                                                                <div v-if="item.name != '사용전'" class="info_title color1">{{item.name}}</div>
                                                                <div v-if="item.name == '사용전'" class="info_title color2">{{item.name}}</div>
                                                                <template v-if="item.name == '사용전'">
                                                                    <div class="myproduct_select_btn" v-if="item.use_time_settings_yn != 1" @click="goods_use_click(index, 'goods')">선 택</div>
                                                                    <div class="myproduct_select_btn" v-if="item.use_time_settings_yn == 1" @click="use_time_setting(item,index,'goods')">선 택</div>
                                                                </template>
                                                                <template v-if="item.name != '사용전'">
                                                                    <div class="myproduct_select_btn" v-if="item.use_time_settings_yn != 1" @click="can_not_continue()">선 택</div>
                                                                    <div class="myproduct_select_btn" v-if="item.use_time_settings_yn == 1" @click="can_not_continue()">선 택</div>
                                                              </template>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </template>
                                            <div class="swiper-pagination" slot="pagination"></div>
                                            <!-- 이게1묶음  -->
                                        </swiper>
                                    </template>
                                </template>

                            </div>

                            <p class="tit01 mt30">내 쿠폰목록</p>
                            <div class="myproduct_wrap">

                                <template v-if="my_coupon_list.length == 0">
                                    <div class="myproduct">
                                        <ul>
                                            <li>
                                                <div style="font-size: .85rem;">이용가능한 상품이 없습니다.</div>
                                            </li>
                                        </ul>
                                    </div>
                                </template>


                                <template v-if="!extention_flag">
                                    <!-- 이게1묶음  -->
                                     <template>
                                        <swiper class="swiper" Navigation :options="swiperOption">
                                            <template v-for="(item, index) in my_coupon_list">
                                                <template  v-if="item.show_chk != true">
                                                    <div class="swiper-slide myproduct" :key="'my_coupon_list_tr'+index">
                                                        <ul class="list_03 myproduct_list">
                                                            <li>
                                                                <div class="info_title">이용상품</div>
                                                                <div class="into_data">{{item.goods_group_name}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title">이용시간</div>
                                                                <div class="into_data">{{item.goods_time}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title">남은시간</div>
                                                                <div class="into_data">{{item.str_left_time}}</div>
                                                            </li>
                                                            <template v-if="item.use_end_check == '1' && item.name == '사용전'">
                                                                
                                                                <li>
                                                                    <div class="info_title color2">만료</div>
                                                                </li>
                                                                
                                                            </template>
                                                            <template v-else>
                                                                <li>
                                                                    <div class="info_title color1">{{item.name}}</div>
                                                                    <div class="myproduct_select_btn" v-if="item.use_time_settings_yn != 1" @click="goods_use_click(index, 'coupon')">선 택</div>
                                                                    <div class="myproduct_select_btn" v-if="item.use_time_settings_yn == 1" @click="use_time_setting(item,index,'coupon')">선 택</div>
                                                                </li>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </template>
                                            <div class="swiper-pagination" slot="pagination"></div>
                                        </swiper>
                                    </template>
                                    <!-- 이게1묶음  -->
                                </template>

                                <template v-if="extention_flag">
                                    <!-- 이게1묶음  -->
                                    <template>
                                        <swiper class="swiper" Navigation :options="swiperOption">
                                            <template v-for="(item, index) in my_coupon_list"><!--
                                                <template v-if="(item.day_count_yn !== 1 && item.time_zone_yn !== 1 && item.hours_yn !== 0 && item.show_chk != true) ||
                                                    (item.day_count_yn === 1 && item.time_zone_yn === 0 && item.hours_yn === 0 && item.show_chk != true)||
                                                    (item.day_count_yn === 0 && item.hours_yn === 1 && item.show_chk != true)||
                                                    (item.day_count_yn === 0 && item.hours_yn === 1 && item.time_zone_yn === 0 && item.show_chk != true)"> -->
                                                <template v-if="item.show_chk != true">
                                                    <div class="swiper-slide myproduct"  :key="'my_coupon_list_tr'+index">
                                                        <ul class="list_03 myproduct_list">
                                                            <li>
                                                                <div class="info_title">이용상품</div>
                                                                <div class="into_data">{{item.goods_group_name}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title">이용시간</div>
                                                                <div class="into_data">{{item.goods_time}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title">남은시간</div>
                                                                <div class="into_data">{{item.str_left_time}}</div>
                                                            </li>
                                                            <li>
                                                                <div class="info_title color1">{{item.name}}</div>
                                                                <div class="myproduct_select_btn" v-if="item.use_time_settings_yn != 1" @click="goods_use_click(index, 'coupon')">선 택</div>
                                                                <div class="myproduct_select_btn" v-if="item.use_time_settings_yn == 1" @click="use_time_setting(item,index,'coupon')">선 택</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </template>
                                            <div class="swiper-pagination" slot="pagination"></div>
                                        </swiper>
                                    </template>
                                    <!-- 이게1묶음  -->
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="using_kind_footer one_btn_footer">
                    <div @click="modal_close" class="btn_close_center">닫기</div>
                </div>
            </div>
        </div>
    </div>

    <!-- 좌석상품 구매할때 내상품, 내쿠폰목록 지도 -->
    <div v-if="popup_code==20" id="alert_layer">
        <div class="using_kind_wrap">
            <div class="using_kind_pop pay_product_list_pop pay_groom_product_list_pop">
                <div class="alert-container">

                    <div class="alert-head">
                        <p  class="pop_tit">좌석 점유</p>
                    </div>
                    <div class="alert-body alert-body2 hidden-scroll">
                        <div class="tab_contents pop_tab">
                            <p class="tit01">내 그룹룸 상품목록</p>
                            <div class="myproduct_wrap">
                                <!-- 이게1묶음  -->
                                <template v-if="my_seat_product_list.length == 0">
                                    <div class="myproduct">
                                        <ul>
                                            <li>
                                                <div style="font-size: .85rem;">이용가능한 상품이 없습니다.</div>
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                                <template>
                                    <swiper ref="awesomeSwiperA" class="swiper" :options="swiperOption">
                                        <div class="swiper-slide myproduct" v-for="(item, index) in my_groom_product_list" :key="'my_groom_product_tr'+index">
                                            <template v-if="item.show_on == true">
                                                <ul class="list_03 myproduct_list">
                                                    <li>
                                                        <div class="info_title">이용상품</div>
	                                                    <div class="into_data">{{item.goods_group_name}}</div>
                                                    </li>
                                                     <li>
                                                        <div class="info_title">이용시간</div>
	                                                    <div class="into_data">{{item.goods_time}}</div>
                                                    </li>
                                                     <li>
                                                        <div class="info_title">남은시간</div>
	                                                    <div class="into_data">{{item.str_left_time}}</div>
                                                    </li>
                                                     <li>
                                                        <div class="info_title">이용상품</div>
	                                                    <div class="into_data">{{item.goods_group_name}}</div>
                                                    </li>
                                                    <li>
                                                        <div class="myproduct_select_btn" v-if="item.selection_plan_code == null" @click="groom_goods_use_click_timecover(index,item)">선 택</div>
                                                    </li>
                                                </ul>
                                            </template>
                                        </div>
                                        <div class="swiper-pagination" slot="pagination"></div>
                                    </swiper>
                                </template>
                                <!-- 이게1묶음  -->


                            </div>
                        </div>
                    </div>
                </div>
                <div class="using_kind_footer one_btn_footer">
                    <div @click="modal_close" class="btn_close_center">닫기</div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="popup_code==21" id="alert_layer">
        <div class="seat_movement_wrap">
            <div class="seat_movement_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <p class="pop_tit02"><span class="tit_img">자리이동</span></p>
                    </div>
                    <div class="alert-body">
                        <div class="seat_move_sector list_05">
                            <template v-for="(item, index) in tab_data" :if="tab_data.length > 1">
                                <span v-if="tab_index === index" class="over" :key="item.map_group_id" @click="floor_tab(item, index)">{{item.tab_name}}</span>
                                <span v-else :key="item.map_group_id" @click="floor_tab(item, index)">{{item.tab_name}}</span>
                            </template>
                        </div>
                        <div class="seat_move">
                            <div class="row tab_01" >
                                <seat :from_pop="from_pop" :map_group_id="map_group_id" @select_seat_data="select_seat" v-bind:style="{background:`url('${map_img}')no-repeat center 0`, width:background_data.img_width + 'px', height:background_data.img_height + 'px'}"></seat>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="seat_movement_footer one_btn_footer alert-footer">
                    <div class="btn_close_center" @click="close_move_seat">닫기</div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="popup_code==22" id="alert_layer">
        <div class="seat_movement_wrap">
            <div class="seat_movement_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <p class="pop_tit02"><span class="tit_img">사물함 이동</span></p>
                    </div>
                    <div class="alert-body">
                        <!-- <div class="status" style="display:flex;" v-for="item in tab_data" :key="item.map_group_id">
                            <div class='room_btn' @click="floor_tab(item)">
                                <span>{{item.tab_name}}</span>
                            </div>
                        </div> -->
                        <div class="list_05 seat_move_sector">
                            <span v-for="item in tab_data" :key="item.map_group_id" @click="floor_tab(item)">{{item.tab_name}}</span>
                        </div>
                        <div class="seat_move">
                            <div class="row tab_01">
                                <locker :from_pop="from_pop" :map_group_id="map_group_id" @select_locker_data="select_locker"></locker>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert-footer one_btn_footer">
                    <div class="btn_close" @click="close_move_locker">닫기</div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="season_alert" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body mh200">
                        <span>이미 이용중인 기간권이 있습니다.</span> <br>
                        <span>추가로 기간권을 사용하시겠습니까?</span>
                    </div>
                    <div class="end_of_footer">
                        <input @click="rem_index = '',season_alert = false" type="button" class="btn_close" value="취소">
                        <input @click="season_chk()" type="button" class="btn_ok" value="확인">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- 그룹룸 이용종료 팝업 -->
    <div v-if="popup_code==24" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico02.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>이용을 종료하시겠습니까?</span>
                        <ul class="close_time">
                            <li class="tit">남은시간 </li>
                            <li>{{groom_left_time}}</li>
                            <li class="tit">종료날짜 </li>
                            <li>{{groom_use_end_time}}</li>
                        </ul>
                    </div>
                    <div class="end_of_footer">
                        <div @click="modal_close" class="btn_close">닫기</div>
                        <div @click="groom_use_end" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="popup_code==25" id="alert_layer">
        <div class="using_kind_wrap">
            <div class="using_kind_pop out_soon_wrap">
                <div class="alert-container">
                    <p class="tit01">퇴실 임박 좌석</p>
                    <div class="out_soon_wrap2 table-wrapper hidden-scroll">
                        <table class="table-head">
                            <thead>
                                <tr>
                                    <th style="width:45%">좌석번호</th>
                                    <th>남은시간</th>
                                </tr>
                            </thead>
                        </table>
                        <div class="scroll-area hidden-scroll">
                            <table class="table-body">
                                <tbody>
                                    <!--  goods_time -->
                                    <tr v-for="(item, index) in out_soon_list" :key="'out_soon_list'+index">
                                        <td style="width:45%">{{item.seat_name}} 번</td>
                                        <td>{{item.left_time}} 분</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="out_soon_footer using_kind_footer one_btn_footer">
                    <div @click="modal_close" class="btn_close_center">닫기</div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="popup_code==27" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico01.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <span>퇴실처리가 완료되었습니다.<br>이용해주셔서 감사합니다.</span>
                    </div>
                    <div class="end_of_footer one_btn_footer">
                        <div @click="modal_close" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
    <div v-if="popup_code==28" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico01.png">
                        </div>
                    </div>
                    <div class="alert-body wordcorrect">
                        <span>좌석이동 중 문제가 발생했습니다.<br>다시시도 해주시기 바랍니다.</span>
                    </div>
                    <div class="end_of_footer one_btn_footer">
                        <div @click="confirm()" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--좌석 선택시 검증 -->
    <div v-if="popup_code==29" id="alert_layer">
        <div class="end_of_wrap">
            <div class="end_of_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico01.png">
                        </div>
                    </div>
                    <div class="alert-body wordcorrect">
                        <span>이미 이용예약중인 좌석입니다.<br> 다른좌석을 선택해주세요.</span>
                    </div>
                    <div class="end_of_footer one_btn_footer">
                        <div @click="confirm()" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 바코드 확대 팝업 -->
    <div v-if="popup_code==30" id="alert_layer">
        <div class="type_of_use_wrap">
            <div class="barcode_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <barcode :value="message" format="CODE128" width="2" font-size="0"></barcode>
                    </div>
                    <div class="alert-body">
                    </div>
                    <div class="barcode_of_use_footer">
                        <div @click="modal_close()" class="btn_close"><font-awesome-icon :icon="['fas', 'times']" /></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ALERT 팝업 NONE CLOSE -->
    <div v-if="popup_code==98" id="alert_layer">
        <div class="join_member_wrap">
            <div class="join_member_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <template v-if="image_type !== '' ">
                                <img src="../../assets/image/pop_ico04.png">
                            </template>
                            <template v-else>
                                <img src="../../assets/image/pop_ico01.png">
                            </template>
                        </div>
                    </div>
                    <div class="alert-body">
                        <span v-html="message"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- ALERT 팝업 -->
    <div v-if="popup_code==99" id="alert_layer">
        <div class="join_member_wrap">
            <div class="join_member_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <template v-if="image_type !== '' ">
                                <img src="../../assets/image/pop_ico04.png">
                            </template>
                            <template v-else>
                                <img src="../../assets/image/pop_ico01.png">
                            </template>
                        </div>
                    </div>
                    <div class="alert-body">
                        <span v-html="message"></span>
                    </div>
                </div>
                <div class="join_member_footer one_btn_footer">
                    <div @click="modal_close" class="btn_ok">확인</div>
                </div>
            </div>
        </div>
    </div>

    <!-- ALERT 팝업 Router 적용 -->
    <div v-if="popup_code==106" id="alert_layer">
        <div class="join_member_wrap">
            <div class="join_member_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <template v-if="image_type !== '' ">
                                <img src="../../assets/image/pop_ico04.png">
                            </template>
                            <template v-else>
                                <img src="../../assets/image/pop_ico01.png">
                            </template>
                        </div>
                    </div>
                    <div class="alert-body">
                        <span v-html="message"></span>
                    </div>
                </div>
                <div class="join_member_footer one_btn_footer">
                    <div @click="modal_close_router" class="btn_ok">확인</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 좌석전용  -->

    <div v-if="popup_code==100" id="alert_layer">
        <div class="type_of_use_wrap">
            <div class="type_of_use_pop choice_start_seat_pop type_of_use_pop_2">
                <div class="alert-container alert-container2">
                    <div class="alert-head">
                        <p class="pop_tit">시작 시간 선택</p>
                    </div>
                    <div class="alert-body3">
                        <template>
                            <div class="money_select_box_wrap choice_start_wrap tC">
                                <div class="select_usingtime">
                                    <b>금일사용시간 :</b>
                                    <select v-model="choice_use_time">
                                        <!-- <option v-for="(item ,index) in choice_use_time_list" :value=index+1 :key="item">{{item}}</option> -->
                                        <option v-for="(item) in choice_use_time_left_list" :value="item" :key="item">{{item}}</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="type_of_use_footer">
                        <div @click="modal_close()" class="btn_close">취소</div>
                        <div @click="use_time_setting_click()" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="popup_code==101" id="alert_layer">
        <div class="type_of_use_wrap">
            <div class="type_of_use_pop choice_extend_pop type_of_use_pop_2">
                <div class="alert-container alert-container2">
                    <div class="alert-head">
                        <p class="pop_tit">연장상품 선택</p>
                    </div>
                    <div class="alert-body3" v-if="!continue_seat_purchase_history_flag">
                        <template>
                            <div class="money_select_box_wrap tC">
                                <div class="select_usingtime">
                                    <b>{{exten_seat_item_name}} - {{exten_seat_item_time}}</b>
                                    <br>
                                    <b>이용연장 하시겠습니까?</b>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="alert-body3" v-if="continue_seat_purchase_history_flag">
                        <template>
                            <div class="money_select_box_wrap tC">
                                <div class="select_usingtime">
                                    <b>기존 : {{already_exten_seat_item_name}} - {{already_exten_seat_item_time}}</b>
                                    <br>
                                    <br>
                                    <b :style="{color:'#e81b1b'}">변경 : {{exten_seat_item_name}} - {{exten_seat_item_time}}</b>
                                    <br>
                                    <br>
                                    <b>으로 이용연장을 변경 하시겠습니까?</b>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="type_of_use_footer type_of_use_footer_btn">
                        <div @click="modal_close()" class="btn_close">취소</div>
                        <div @click="use_extention_ask_for_check()" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 그룹룸 전용 -->

    <div v-if="popup_code==102" id="alert_layer">
        <div class="type_of_use_wrap">
            <div class="type_of_use_pop type_of_use_pop3">
                <div class="alert-container2">
                    <div class="alert-head">
                        <p class="pop_tit">시작 시간 선택</p>
                    </div>
                    <div class="alert-body3">
                        <template>
                            <div class="money_select_box_wrap choice_start_wrap tC">
                                <div class="select_usingtime">
                                    <b>금일사용시간 :</b>
                                    <select v-model="choice_use_time">
                                        <!-- <option v-for="(item ,index) in choice_use_time_list" :value=index+1 :key="item">{{item}}</option> -->
                                        <option v-for="(item) in choice_use_time_left_list" :value="item" :key="item">{{item}}</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="type_of_use_footer">
                        <div @click="modal_close()" class="btn_close">취소</div>
                        <div @click="groom_goods_use_click('index_not_use')" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 그룹룸 예약 결제 확인 팝업 -->
    <div v-if="popup_code==103" class="alert-layer">
        <div class="door_open_wrap">
            <div class="door_open_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico01.png">
                        </div>
                    </div>
                    <div class="alert-body wordcorrect">
                        <span>그룹룸 예약 결제 페이지로 이동합니다.</span>
                    </div>
                    <div class="type_of_use_footer one_btn_footer">
                        <div @click="go_reservation_pay" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 비밀번호 변경시 문자인증 팝업 -->
    <div v-if="popup_code==104" id="alert_layer">
        <div class="type_of_use_wrap">
            <div class="type_of_use_pop identity_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <p class="pop_tit">본인 인증</p>
                    </div>
                    <div class="alert-body">
                        <template>
                            <div class="money_select_box_wrap  choice_start_wrap">
                                <div class="select_usingtime">
                                    <b>휴대폰번호 :</b>
                                    <select v-model="choice_use_time">
                                        <!-- <option v-for="(item ,index) in choice_use_time_list" :value=index+1 :key="item">{{item}}</option> -->
                                        <option v-for="(item) in choice_use_time_left_list" :value="item" :key="item">{{item}}</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="type_of_use_footer">
                        <div @click="modal_close()" class="btn_close">취소</div>
                        <div @click="groom_goods_use_click('index_not_use')" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 바코드 관련 -->
    <div v-if="popup_code==105" class="alert-layer">
        <div class="door_open_wrap">
            <div class="door_open_pop barcode_pop">
                <div class="alert-container">
                    <div class="alert-head">
                        <div class="alert-icon">
                            <img src="../../assets/image/pop_ico01.png">
                        </div>
                    </div>
                    <div class="alert-body">
                        <barcode v-model="barcode_value"></barcode>
                    </div>
                    <div class="type_of_use_footer">
                        <div @click="modal_close" class="btn_ok">확인</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 결제시 이용안내 팝업  -->
    <div v-if="popup_code==107" id="alert_layer">
        <div class="join_member_wrap">
            <div class="join_member_pop">
                <div class="alert-container w100">
                    <div class="alert-body-sub">
                        <!-- <span v-html="message"></span> -->
                        <div class="">
                            <div class="barcode-info-body-tab">
                                <div @click="tab_select(0)" class="tab-kind barcode-seat-kind active">
                                    <span>좌석</span>
                                </div>
                                <div @click="tab_select(1)" class="tab-kind barcode-seat-kind">
                                    <span>사물함</span>
                                </div>
                                <div @click="tab_select(2)" class="tab-kind barcode-seat-kind">
                                    <span>그룹룸</span>
                                </div>
                            </div>
                            <!-- <div class="barcode-info-body-using"> -->
                            <div class="guide-info-body-using">
                                <!--
                                <div v-if="tab_kind == 0">
                                    <span v-html="decodeHtmlEntities(guide_data.seat_guide)"></span>
                                </div>
                                <div v-else-if="tab_kind == 1">
                                    <span v-html="decodeHtmlEntities(guide_data.locker_guide)"></span>
                                </div>
                                <div v-else-if="tab_kind == 2">
                                    <span v-html="decodeHtmlEntities(guide_data.groom_guide)"></span>
                                </div>
                                -->
                                <div v-if="tab_kind == 0">
                                    <span v-if="guide_data.seat_guide && guide_data.seat_guide.trim() !== ''" v-html="decodeHtmlEntities(guide_data.seat_guide)"></span>
                                    <span v-else style="color: #a0a0a0;">등록된 데이터가 없습니다.</span>
                                </div>
                                <div v-else-if="tab_kind == 1">
                                    <span v-if="guide_data.locker_guide && guide_data.locker_guide.trim() !== ''" v-html="decodeHtmlEntities(guide_data.locker_guide)"></span>
                                    <span v-else style="color: #a0a0a0;">등록된 데이터가 없습니다.</span>
                                </div>
                                <div v-else-if="tab_kind == 2">
                                    <span v-if="guide_data.groom_guide && guide_data.groom_guide.trim() !== ''" v-html="decodeHtmlEntities(guide_data.groom_guide)"></span>
                                    <span v-else style="color: #a0a0a0;">등록된 데이터가 없습니다.</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="join_member_footer one_btn_footer">
                    <div @click="modal_close" class="btn_ok">닫기</div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import crypto from 'crypto';
import * as config from '../../javascript/config';
import vue from 'vue';

// 공통함수
import common from '@/assets/js/common.js';
import axios from 'axios';
import moment from 'vue-moment';
import VueBarcode from 'vue-barcode';
import { EventBus } from '../../main.js';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'  ;

vue.use(moment);
export default {
    name: 'pop',
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            message: '',
            popup_code: this.$store.getters.get_popup_code.ALL_CLOSE,
            router: '',
            image_type: '',
            //현재 해당좌석에 연장상품이 걸려있는지 아닌지를 판단할 flag
            continue_seat_purchase_history_flag: false,
            time_continue_flag: false, // 당일권 연장여부 
            seat_move_flag: false, // 좌석이동 여부
            //좌석과 사물함 이동시 필요한 TAB 데이터
            tab_data: Object,
            map_img: '',
            map_group_id: '', // 탭(층) 에 대한 id 를 담을 변수 - 사용처 => 탭클릭시 id를 담고 seat / locker 쪽에 탭 id 전달

            //좌석 이동시 필요한 flag 성 데이터
            seat_flag: false, // 팝업이 뜬후 좌석이동 선택시 seat 리스트를 보여줄지를 판단하는 flag
            from_pop: true, // seat.vue 로 보내줄 props 데이터

            //좌석 이동에 필요한 좌석 데이터
            sel_seat_use_id: '', // 사용중인 좌석 use id
            sel_seat_id: '', // 사용중인 좌석 seat id
            move_seat_id: '', // 이동할 좌석 id
            move_seat_name: '', // 이동할 좌석 name
            sel_seat_name: '',
            //사물함 이동시 필요한 flag 성 데이터
            locker_flag: false, // 팝업이 뜬후 사물함 이동 선택시 locker 리스트를 보여줄지를 판단하는 flag
            from_pop: true, // locker.vue 로 보내줄 props 데이터
            //그룹룸 이용종료에 필요한 좌석 데이터
            sel_groom_use_id: '', // 사용중인 좌석 use id
            sel_groom_id: '', // 사용중인 좌석 seat id
            //사물함 이동에 필요한 좌석 데이터
            sel_locker_use_id: '', // 사용중인 사물함 use id
            sel_locker_id: '', // 사용중인 사물함 seat id
            move_locker_id: '', // 이동할 사물함 id
            move_locker_name: '', // 이동할 사물함 name
            //사물함 연장 관련

            //선택된 좌석 및 라커 및 그룹룸의 info
            locker_info: [],
            exten_locker_flag: false,
            seat_info: [],
            my_seat_product_list: [],
            my_coupon_list: [],
            my_groom_product_list: [],
            groom_info: [],
            //좌석배정 데이터
            extention_data: [],
            //좌석 이용종료 관련 데이터
            seat_use_end_time: '',
            seat_left_time: '',
            seat_expire_time: '',
            //그룹룸 이용종료 관련 데이터
            groom_use_end_time: '',
            groom_left_time: '',
            //그룹룸 이용연장 인지를 판단할 flag
            extention_groom_flag: false,
            //그룹룸 예약 인지를 판단할 flag
            reservation_groom_flag: false, 
            //그룹룸 이용연장 관련 데이터
            exten_groom_data: [],
            exten_groom_index: 0,
            exten_groom_use_end_datetime: '',
            // 내상품, 내쿠폰 목록 (db최신화 떄문에 필요할것 같아서 통신이용할예정)

            // 예약번호
            reservation_number: '',

            season_alert: false, // 내상품중 기간권을 사용하려 할때 , 이미 사용중인 기간권이 있을경우 보여줄 alert popup
            season_flag: false,
            rem_index: '',

            dd: null,
            hh: null,
            mm: null,
            //내가 가지고있는 좌석 상품들중 , 금일사용시간 선택을 할때 필요한 데이터
            choice_use_time: 0, // 값이 1일경우 1시간,
            choice_use_time_left_list: [],
            left_time_for_send_server: 0,
            index_for_selTime: 0,
            special_goods_flag: false, // 시간충전권 , 기간권 , 1일시간권 이 아닌 주간권,야간권,주간기간권,야간기간권을 체크하기위한 flag
            special_goods_endtime: '',

            //좌석 연장할 상품 정보
            exten_seat_item_name: '',
            exten_seat_item_time: '',
            request_data_info: [], // 내상품 사용시 서버로 보낼 데이터를 담을 상품정보 배열
            //이미 예약되어있는 좌석 연장상품의 정보
            already_exten_seat_item_name: '',
            already_exten_seat_item_time: '',
            already_continue_seat_purchase_history_id: '',
            //이미 사용중인 좌석의 사용예정시간
            seat_use_hours_plan: 0,
            //이미 연장되어있는 상품의 정보 (이용종류 팝업에서 보여줄 연장정보)
            useinfo_exten_seat_item_name: '',
            useinfo_exten_seat_item_time: '',
            useinfo_exten_seat_use_our_plan: '',
            //현재사용중인 좌석의 puchase id
            seat_purchase_history_id: '',
            //퇴실 임박 좌석
            out_soon_list: [],
            seat_goods_type: '',
            //시간충전권인지 아닌지 여부
            time_goods_flag: 0,
            //영수증 출력 여부
            receipt_flag: 0,
            // 배경이미지 데이터
            background_data: [],
            tab_index: 0,
            //이용종료 카운트
            use_end_index: 0,

            barcode_value: '',
            // 구매로직 생략하며 좌석 점유시 필요한 flag
            seat_use_exten_flag: false,
            seat_use_txt_flag: false,
            mygroom_reser: [],
            mygroom_using: [],
            swiperOption: {
               pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
            extention_flag: false,
            doubleSubmit: false,

            tab_kind: 0, //이용안내 탭종류 
            guide_data: this.$store.getters.get_guide_data,
        }

    },
    directives: {
      swiper: directive
    },
    components: {
        'barcode': VueBarcode
    },
    methods: {
        modal_close() {
            this.$store.commit('set_reset_popup_type');
            this.locker_flag = false;
            this.tab_kind = 0;
        },
        modal_close_router() {
            let router_url = this.$store.getters["get_popup_type"].router;
            this.$store.commit('set_reset_popup_type');
            this.$router.push(router_url);
        },
        parents_sms_send_bak() {
            const type = config.REQ_PARENTS_SEND_SMS;
            this.$store.dispatch(type.action_name, {
                type: type,
                data: {}
            }).then(response => {
                this.$store.commit('set_reset_popup_type');
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        async parents_sms_send(){
            // 260108 퇴실알림톡 본인 발송 여부 추가
            const parents_sms_type = config.REQ_PARENTS_SEND_SMS;
            const user_out_sms_type = config.REQ_USER_OUT_SEND_SMS;
            try {
                await this.$store.dispatch(parents_sms_type.action_name, {
                    type: parents_sms_type,
                    data: {}
                });
                if(this.$store.getters['get_store_option'].out_send_check == '1'){
                    await this.$store.dispatch(user_out_sms_type.action_name, {
                        type: user_out_sms_type,
                        data: {}
                    });
                }
                this.$store.commit('set_reset_popup_type');

            } catch (error) {
                console.log('error=============>', error);
            }
        },
        // 좌석 이동 진행 프로세스
        open_seatMap() {
            this.seat_flag = !this.seat_flag;
            this.tab_data = this.$store.getters['get_map_group_list'];
            this.floor_tab(this.tab_data[0], 0);
            this.popup_code = 21;
            this.$store.commit('setFrom_front',
                'none'
            );

        },
 
        select_seat(sel_data) {
            // 코드 추가 - 2020-11-26
            var my_seat_data = this.$store.getters['get_my_seat_data'];
            if(my_seat_data[0].seat_id == sel_data.seat_id) {
                 const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `해당 좌석으로 이동이 불가능합니다. `,
                    router: '',
                    image_type: 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);
                return;

            }
            if(my_seat_data[0].seat_type_code != sel_data.seat_type_code){
                 const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `해당 좌석으로 이동이 불가능합니다. `,
                    router: '',
                    image_type: 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);
                return;

            }
            if(sel_data.seat_status_code != 'SEAT_AVAILABLE'){
                 const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `해당 좌석으로 이동이 불가능합니다. `,
                    router: '',
                    image_type: 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);
                return;

            }
            if (my_seat_data[0].seat_id != sel_data.seat_id && sel_data.seat_status_code == 'SEAT_AVAILABLE' && sel_data.seat_type_code == my_seat_data[0].seat_type_code) {

                this.move_seat_id = sel_data.seat_id;
                this.move_seat_name = sel_data.seat_name;
                // 스토어에서 가져온 my seat use id 를 저장함
                this.sel_seat_use_id = my_seat_data[0].seat_use_id;
                this.sel_seat_id = my_seat_data[0].seat_id;
                // 보여줄 팝업 의 팝업코드 삽입
                this.popup_code = 5;
            }



        },
        move_seat() {
            if (this.sel_seat_id != this.move_seat_id && this.sel_seat_use_id === this.$store.state.select_my_seat[0].seat_use_id) {
                const type = config.REQ_USING_SEAT_CHECK;
                const data = {
                    seat_id: this.move_seat_id
                };

                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    if(response.data[0].seat_status_code == "SEAT_AVAILABLE"){
                        const type = config.REQ_SEAT_MOVE_UPDATE;
                        const request_data = {
                            data: {
                                'seat_use_id': this.sel_seat_use_id, // 현재 내가 사용중인 좌석 use id
                                'seat_id': this.move_seat_id // 이동할 좌석의 seat id
                            }
                        };
                        this.$store.dispatch(type.action_name, {
                            type: type,
                            data: request_data
                        }).then(response => {
                            if (response.message == "complete") {
                                this.modal_close();
                                this.$store.commit('set_seat_move_flag', !this.$store.getters.get_seat_move_flag);
                            } else {
                                const alert_param = {
                                    code: this.$store.getters['get_popup_code'].POPUP_MOVE_PROBLEM
                                };
                                this.$store.commit('set_popup_type', alert_param);
                                return;
                            }
                        }).catch(function (error) {
                            console.log('error=============>', error);
                        });
                    }else{
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `해당 좌석으로 이동이 불가능합니다. `,
                            router: '',
                            image_type: 'warning'
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        return;
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });


                

            } else {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `해당 좌석으로 이동이 불가능합니다. `,
                    router: '',
                    image_type: 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }

        },
        //좌석 이용연장 프로세스
        move_payment_seat_sub() {

            var store_pay_info = this.$store.getters['getStore_pay_info'];
            if (store_pay_info) {
                if (this.continue_seat_purchase_history_flag) {
                    this.popup_code = 19;
                } else {
                    this.move_payment_seat();
                }
                this.$store.commit('setFrom_front', 'none');
            } else {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_SEAT_USE_PRODUCT_COUPON_LIST,
                }
                this.$store.commit('set_popup_type', alert_param);
            }
        },
        move_payment_seat() {
            let continue_now_date = this.$moment().format("YYYYMMDDHHmm00");
            let already_use_end_date = this.$moment(this.use_good_endtime).add(-5, 'minute').format("YYYYMMDDHHmm00");
            if(parseInt(continue_now_date) >= parseInt(already_use_end_date)){                       
                const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `상품권 만료시간 5분전에는 연장 할 수 없습니다.`,
                router: '', 
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }

            //북마크
            var user_data = this.$store.getters['getUser'];
            var user_id = user_data.user_id;
            const my_info_data = {
                'user_id': user_id
            };

            // this.$store.commit('set_use_extend_flag', {
            //     'use_extend_flag': true
            // })
            this.$store.commit('setExtention_flag', {
                value: true
            });

            this.modal_close();
            var router = this.$router;
            router.push('/payment-seat') // 이동 위치를 입력
        },
        //그룹룸 이용연장 프로세스
        move_payment_groom() {
            //북마크
            var user_data = this.$store.getters['getUser'];
            var user_id = user_data.user_id;
            const my_info_data = {
                'user_id': user_id
            };

            const type = config.REQ_GROOM_CONTINUE_CHECK;
            this.$store.dispatch(type.action_name, {
                type: type,
                data: {}
            }).then(response => {

                //   for(let i=0; i < response.data.length; i++){

                //     if (response.data[i].continue_yn === 1){
                //       const alert_param = {
                //           code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                //           message: `<span>이미 연장등록한 상품이 있습니다</span>. `,
                //           router: '/',
                //       };
                //       this.$store.commit('set_popup_type', alert_param);
                //       return;
                //     }

                //   }

                this.modal_close();
                var router = this.$router;
                router.push('/payment-group_room') // 이동 위치를 입력

            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        //사물함 이용연장/이동 프로세스
        locker_using_chkbox(index) {
            if (index == 0) {
                this.modal_close();
                var router = this.$router;
                router.push('/payment-locker') // 이동 위치를 입력
            } else {
                this.open_lockerMap();
            }
        },
        locker_using_route() {
            var chk_obj = document.getElementsByName("agrre_yn_locker");
            if (chk_obj[0].checked) {
                this.move_payment_locker();
            } else if (chk_obj[1].checked) {
                this.open_lockerMap();
            }
        },
        move_payment_locker() {
            this.modal_close();
            var router = this.$router;
            router.push('/payment-locker') // 이동 위치를 입력
        },
        // 사물함 이동 진행 프로세스
        open_lockerMap() {
            this.locker_flag = !this.locker_flag;
            this.tab_data = this.$store.getters['get_map_group_list'];
            this.floor_tab(this.tab_data[0], 0);
            this.popup_code = 22;
        },
        select_locker(sel_data) {

            // store에 셋팅된 my locker data 정보 가져옴
            var my_locker_data = this.$store.getters['get_my_locker_data'];

            // 새로 이동할 사물함 id 와 name 을 저장함
            this.move_locker_id = sel_data.locker_id;
            this.move_locker_name = sel_data.locker_name;
            // 스토어에서 가져온 my locker use id 를 저장함
            this.sel_locker_use_id = my_locker_data[0].locker_use_id;
            // 보여줄 팝업 의 팝업코드 삽입
            this.popup_code = 13;
        },
        move_locker() {
            const type = config.REQ_LOCKER_MOVE_UPDATE;
            const request_data = {
                data: {
                    'locker_use_id': this.sel_locker_use_id, // 현재 내가 사용중인 사물함 use id
                    'locker_id': this.move_locker_id // 이동할 사물함의  id
                }
            };

            this.$store.dispatch(type.action_name, {
                type: type,
                data: request_data
            }).then(response => {
                if (response.message == "complete") {
                    this.modal_close();
                    this.locker_flag = !this.locker_flag;
                    this.$store.commit('set_locker_move_flag', !this.$store.getters.get_locker_move_flag);
                }

            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        // 좌석 사용종료
        askFor_seat_use_end() {
            //북마크111
            // store에 셋팅된 my seat data 정보 가져옴
            var my_seat_data = this.$store.getters['get_my_seat_data'];
            // 기억
            //만약 내가사용하던 좌석이 고정석이면 이동불가 팝업을 띄워주고 리턴시킨다.
            if (my_seat_data[0].main_seat_type_code == "FIXED") {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_CHECK_OUT_TEXT,
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }
            // 스토어에서 가져온 my seat use id 를 저장함

            this.sel_seat_use_id = my_seat_data[0].seat_use_id;
            this.sel_seat_id = my_seat_data[0].seat_id;
            this.seat_use_end_time = my_seat_data[0].use_end_datetime;
            this.seat_expire_time = my_seat_data[0].goods_end_datetime;

            const type = config.REQ_SEAT_USE_GET_LIST;
            const request_data = {
                data: {

                }
            };

            this.$store.dispatch(type.action_name, {
                type: type,
                data: request_data
            }).then(response => {
                // 250821 모바일 사용여부 n이면 퇴실 불가로 변경 
                if(response.data[0].mobile_use_yn == 0){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `해당 상품은 모바일에서<br>종료할 수 없습니다.<br> 관리자에게 문의해주세요.`,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return;
                }

                let nowDate = this.$moment();
                let endDate = this.$moment(response.data[0].use_end_datetime);

                let diffTime = {
                    day : this.$moment.duration(endDate.diff(nowDate)).asDays() != 0? Math.floor(this.$moment.duration(endDate.diff(nowDate)).asDays()) + "일 ":"",
                    hour : this.$moment.duration(endDate.diff(nowDate)).hours() != 0?this.$moment.duration(endDate.diff(nowDate)).hours() + "시간 ":"",
                    minute : this.$moment.duration(endDate.diff(nowDate)).minutes() != 0?this.$moment.duration(endDate.diff(nowDate)).minutes() + "분":"",
                    totalMinute: this.$moment.duration(endDate.diff(nowDate)).asMinutes()
                }
                this.seat_left_time = diffTime.day + diffTime.hour + diffTime.minute;

                if (diffTime.totalMinute <= 5) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `상품 만료시간 5분전에는<br>종료 할 수 없으며,<br>5분 후 자동 종료 처리<br> 됩니다.`,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return;
                }

                // 보여줄 팝업 의 팝업코드 삽입 - 이용종료 code = 7

                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_USE_FINISH_S,
                };

                this.$store.commit('set_use_end_info', {
                    seat_id: my_seat_data[0].seat_id,
                    seat_use_id:  my_seat_data[0].seat_use_id,
                    seat_left_time: this.seat_left_time,
                    seat_use_end_time: my_seat_data[0].use_end_datetime,
                    seat_expire_time: my_seat_data[0].goods_end_datetime
                });
                this.$store.commit('set_popup_type', alert_param);

            }).catch(function (error) {
                console.log('error=============>', error);
            });
            this.$store.commit('setFrom_front', 'none');

        },

        // 그룹룸 사용종료
        askFor_groom_use_end() {

            this.groom_use_end_time = this.groom_info[0].use_end_datetime;
            // 이걸로 남은시간 계산

            var groom_today = this.get_today();

            var groom_date1 = new Date(groom_today);
            var groom_date2 = new Date(this.groom_info[0].use_end_datetime += ':00');
            var groom_mil_time = groom_date2 - groom_date1;

            //var groom_dd = Math.floor((groom_mil_time / (1000 * 60 * 60 * 24)));
            var groom_hh = Math.floor((groom_mil_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var groom_mm = Math.floor((groom_mil_time % (1000 * 60 * 60)) / (1000 * 60));
            this.groom_left_time = groom_hh + '시간' + ' ' + groom_mm + '분';

            // 보여줄 팝업 의 팝업코드 삽입 - 이용종료 code = 7
            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_GROOM_END,
            };
            this.$store.commit('set_popup_type', alert_param);

        },
        seat_use_end() {
          if(this.doubleSubmit)
            return;
          this.doubleSubmit = true;
            //let out_send_check = this.$store.getters.get_store_option.out_send_check;
            const type = config.REQ_SEAT_USE_DELETE;
            const request_data = {
                'data': {
                    'seat_use_id': this.sel_seat_use_id,
                    'seat_id': this.sel_seat_id,
                    'out_send_check':this.$store.getters['get_store_option'].out_send_check
                }
            };
            this.$store.dispatch(type.action_name, { 
                type: type,
                data: request_data
            }).then(response => {
                if (response.message == "complete") {
                    this.modal_close();
                    this.$store.commit('set_seat_move_flag', !this.$store.getters.get_seat_move_flag);

                    // const alert_param = {
                    //     code: this.$store.getters['get_popup_code'].POPUP_END_GUIDE,
                    // };
                    // this.$store.commit('set_popup_type', alert_param);
                }
              this.doubleSubmit = false;

            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },

        groom_use_end() {

            const type = config.REQ_GROOM_USE_DELETE;
            const request_data = {
                'data': {
                    'groom_use_id': this.groom_info[0].groom_use_id,
                    'groom_id': this.groom_info[0].groom_id,
                    'exten_flag': this.extention_groom_flag
                }
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: request_data
            }).then(response => {
                if (response.message == "complete") {
                    this.modal_close();
                    this.$store.commit('set_groom_move_flag', !this.$store.getters.get_groom_move_flag);
                }

            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },

        floor_tab(item, index) {
            this.map_img = config.SYS_HOST + `/images/kiosk/${item.map_img}`;
            this.map_group_id = item.map_group_id;
            this.background_data = item;
            this.tab_index = index;
        },
        //좌석 상품 되묻는 팝업 확인버튼
        product_use_ok() {

            const type = config.REQ_SEAT_USE_UPDATE;
            const data = {
                data: {
                    'seat_purchase_history_id': this.extention_data[0].seat_purchase_history_id,
                    'hour': this.extention_data[0].hour,
                    'use_end_datetime': this.extention_data[0].end_date
                }
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                this.modal_close();
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `${this.seat_info[0].seat_name}번 좌석이 배정되었습니다. `,
                    router: '/',
                };
                this.$store.commit('set_popup_type', alert_param);
                var router = this.$router;
                router.push('/');
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },

        //오늘날짜 리턴함수
        get_today() {
            return this.$moment().format("YYYY-MM-DD HH:mm:00");
        },
        convertDate(strDate) {
            var date = strDate.split(" ");
            return date[0];
        },
        convertTime(strDate) {
            var time = strDate.split(" ");
            return time[1];
        },
        timeToDateTime(minute, time_type, end_date) {
            var str_left_time = "";

            let nowDate = this.$moment();
            let endDate = this.$moment(end_date);

            let diffTime = {
                day : this.$moment.duration(endDate.diff(nowDate)).days() != 0?this.$moment.duration(endDate.diff(nowDate)).days() + "일 ":"",
                hour : this.$moment.duration(endDate.diff(nowDate)).hours() != 0?this.$moment.duration(endDate.diff(nowDate)).hours() + "시간 ":"",
                minute : this.$moment.duration(endDate.diff(nowDate)).minutes() != 0?this.$moment.duration(endDate.diff(nowDate)).minutes() + "분":"",
                totalMinute: this.$moment.duration(endDate.diff(nowDate)).asMinutes()
            }

            if (time_type != "" && time_type == "일") {
                str_left_time = diffTime.day + diffTime.hour + diffTime.minute;
            } else {
                var hour = parseInt(parseInt(minute) / 60);
                var min = parseInt(parseInt(minute) % 60);
                if (hour != 0) {
                    str_left_time = hour + "시간";
                }
                if (min != 0) {
                    if (str_left_time == "") {
                        str_left_time = min + "분";
                    } else {
                        str_left_time += " " + min + "분"
                    }

                } else {
                    if (str_left_time == "") {
                        str_left_time = "";
                    }
                }
            }
            return str_left_time;
        },
        use_time_setting_click(goods_type) {
            var seat_data = this.$store.getters['get_select_seat'];
            var str = '';
            var str_array;
            str = this.choice_use_time;
            str_array = str.split('시간');
            let request_data = new Object;
            var flag = false;
            if (this.choice_use_time == this.special_goods_endtime + '까지 사용') {
                flag = true;
            }
            if (str_array[0] == '남은') {
                this.choice_use_time = this.left_time_for_send_server;
            } else {
                this.choice_use_time = Number(str_array[0]) * 60;
            }

            if (this.seat_goods_type == 'goods') {
                this.my_seat_product_list[this.index_for_selTime].use_hours_plan = this.choice_use_time;

                this.my_seat_product_list[this.index_for_selTime].seat_id = seat_data[0].seat_id;
                var extention_flag = this.$store.getters['getExtention_flag'];

                request_data.data = this.my_seat_product_list[this.index_for_selTime];
                if (this.my_seat_product_list[this.index_for_selTime].day_count_yn == 1 && this.my_seat_product_list[this.index_for_selTime].time_zone_yn == 0 && this.my_seat_product_list[this.index_for_selTime].hours_yn) {
                    for (let i = 0; i < this.my_seat_product_list.length; i++) {
                        if (!this.season_flag && this.my_seat_product_list[i].day_count_yn == 1 && this.my_seat_product_list[i].time_zone_yn == 0 && this.my_seat_product_list[i].hours_yn && this.my_seat_product_list[i].name == '사용중') {
                            this.season_alert = true;
                            this.rem_index = this.index_for_selTime;
                            return;
                        }
                    }
                }
            } else if (this.seat_goods_type == 'coupon') {
                this.my_coupon_list[this.index_for_selTime].use_hours_plan = this.choice_use_time;

                this.my_coupon_list[this.index_for_selTime].seat_id = seat_data[0].seat_id;

                var extention_flag = this.$store.getters['getExtention_flag'];

                request_data.data = this.my_coupon_list[this.index_for_selTime];
                if (this.my_coupon_list[this.index_for_selTime].day_count_yn == 1 && this.my_coupon_list[this.index_for_selTime].time_zone_yn == 0 && this.my_coupon_list[this.index_for_selTime].hours_yn) {
                    for (let i = 0; i < this.my_coupon_list.length; i++) {
                        if (!this.season_flag && this.my_coupon_list[i].day_count_yn == 1 && this.my_coupon_list[i].time_zone_yn == 0 && this.my_coupon_list[i].hours_yn && this.my_coupon_list[i].name == '사용중') {
                            this.season_alert = true;
                            this.rem_index = this.index_for_selTime;
                            return;
                        }
                    }
                }
            }
            this.request_data_info = request_data;

            this.exten_seat_item_name = this.request_data_info.data.goods_group_name;
            var pic_time = this.request_data_info.data.use_hours_plan;
            var al_pic_time;
            if ((pic_time / 60) % 1 === 0) {
                this.exten_seat_item_time = (pic_time / 60) + '시간';
            } else {
                var min;
                min = pic_time % 60;
                pic_time = pic_time - min;
                this.exten_seat_item_time = (pic_time / 60) + '시간 ' + min + '분';
            }

            if (this.continue_seat_purchase_history_flag) {
                var chk_flag = false;
                for (let i = 0; i < this.my_seat_product_list.length; i++) {
                    if (this.already_continue_seat_purchase_history_id == this.my_seat_product_list[i].seat_purchase_history_id) {
                        chk_flag = true;
                        this.already_exten_seat_item_name = this.my_seat_product_list[i].goods_group_name;
                        al_pic_time = this.already_exten_seat_item_time;

                        if ((al_pic_time / 60) % 1 === 0) {
                            this.already_exten_seat_item_time = (al_pic_time / 60) + '시간';
                        } else {
                            var min;
                            min = al_pic_time % 60;
                            al_pic_time = al_pic_time - min;
                            this.already_exten_seat_item_time = (al_pic_time / 60) + '시간 ' + min + '분';
                        }
                    }
                }
                if (!chk_flag) {
                    for (let i = 0; i < this.my_coupon_list.length; i++) {
                        if (this.already_continue_seat_purchase_history_id == this.my_coupon_list[i].seat_purchase_history_id) {
                            chk_flag = true;
                            this.already_exten_seat_item_name = this.my_coupon_list[i].goods_group_name;
                            if ((al_pic_time / 60) % 1 === 0) {
                                this.already_exten_seat_item_time = (al_pic_time / 60) + '시간';
                            } else {
                                var min;
                                min = al_pic_time % 60;
                                al_pic_time = al_pic_time - min;
                                this.already_exten_seat_item_time = (al_pic_time / 60) + '시간 ' + min + '분';
                            }
                        }
                    }
                }
            }

            if (extention_flag.value) {
                this.popup_code = 101;
            } else {
                var nowDate = this.$moment().format("YYYY-MM-DD HH:mm:00");
                request_data.data.startDate_for_receipt = nowDate;
                request_data.data.exten_yn = false;
                const type = config.REQ_SEAT_USE_INSERT;
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: request_data
                }).then(response => {
                    if (response.message == "complete") {
                        this.modal_close();
                        this.$store.commit('set_seat_move_flag', !this.$store.getters.get_seat_move_flag);
                        var store_pay_info = this.$store.getters['getStore_pay_info'];
                        if (!store_pay_info) {
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `좌석이 점유되었습니다.`,
                                router: '',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                        }

                    }
                    this.$store.commit('set_seat_move_step', 6);
                    this.$store.commit('set_Item_update_check', {
                        item_id: seat_data[0].seat_id,
                        item: 'seat',
                        last_status: 'using'
                    });
                }).catch(function (error) {
                    console.log('error=============>', error);
                });

            }

        },
        async use_time_setting(data,index,goods_type){          
          let checkLock = await this.lock_extention();
          if(!checkLock)           
            return;
          
            this.seat_goods_type = goods_type;

            var max_use_time = data.max_use_time;

            this.choice_use_time = 0;
            this.choice_use_time_left_list = [];
            var remainder_chk = !this.special_goods_flag;

            this.index_for_selTime = index;

            if (data.day_count_yn === 1 && data.time_zone_yn === 0 && data.hours_yn === 0) {
                //기간권
                if(data.code == "WAITING"){
                    // 기간권 상품구매만 하고 아직 사용하지 않았을시엔 use_end_datetime 존재하지않아 사용시간 계산 불가
                    var array_length = max_use_time;
                    for (let i = 0; i <  24; i++) {
                        var time = i + 1;
                        this.choice_use_time_left_list.push(time + "시간");
                    }

                }else{
                    var nowDate = this.$moment();
                    var endDate = this.$moment(data.use_end_datetime);
                    var array_length = this.$moment.duration(endDate.diff(nowDate)).asHours();
                    this.left_time_for_send_server = Math.floor(this.$moment.duration(endDate.diff(nowDate)).asMinutes()) + 1;

                    if(this.extention_flag){

                        if(data.continue_goods_yn == 0){
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `해당상품은 연장등록이 불가능한 상품입니다.`,
                                router: '',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;
                        }

                        if(data.seat_purchase_history_id == this.seat_purchase_history_id){
                            this.left_time_for_send_server = this.left_time_for_send_server - this.seat_use_hours_plan;
                            array_length = (array_length * 60 - this.seat_use_hours_plan) / 60;
                        }

                    }
                    if(array_length > max_use_time){
                        array_length = max_use_time;
                    }
                    for (let i = 0; i <  Math.floor(array_length); i++) {
                        var time = i + 1;
                        this.choice_use_time_left_list.push(time + "시간");
                    }

                    if(remainder_chk && Number(max_use_time) > array_length && !Number.isInteger(array_length)){
                        this.choice_use_time_left_list.push('남은시간 모두사용');
                    }
                }


            }else{
                this.left_time_for_send_server = data.left_time;
                var array_length = data.left_time / 60;

                if(this.extention_flag){
                    if(data.continue_goods_yn == 0){
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `해당상품은 연장등록이 불가능한 상품입니다.`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        return;
                    }

                    if(data.seat_purchase_history_id == this.seat_purchase_history_id){
                        this.left_time_for_send_server = this.left_time_for_send_server - this.seat_use_hours_plan;
                        array_length = (data.left_time - this.seat_use_hours_plan) / 60;
                    }
                }

                if(array_length > max_use_time){
                    array_length = max_use_time;
                }

                for (let i = 0; i < Math.floor(array_length); i++) {
                    var time = i + 1;
                    this.choice_use_time_left_list.push(time + "시간");
                }



                if(remainder_chk && Number(max_use_time) > array_length && !Number.isInteger(array_length)){
                    this.choice_use_time_left_list.push('남은시간 모두사용');
                }
            }


            this.choice_use_time = this.choice_use_time_left_list[0]; // defalut 값 셋팅

            // this.modal_close();
            this.popup_code = 100;
        },
        async lock_extention(){
          let flag = false;
          const condition_type = config.REQ_UPDATE_LOCK_EXTENTION_STATUS;
          const condition_data = {
              'item_id': this.$store.getters['get_select_seat'][0].seat_id,
              'item': 'seat'
          };
          await this.$store.dispatch(condition_type.action_name, {
              type: condition_type,
              data: condition_data
          }).then(response => {
              if (!response.result) {
                clearInterval(this.lock_timer);
                const alert_param = {
                  code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                  message: '유효성 인증에 실패하여 처음화면으로 돌아갑니다.',
                  router: '',
                }
                this.$store.commit('set_popup_type', alert_param);
                setTimeout(() => {this.$router.push('/')}, 3000);
                flag = false;
              }else{
                flag = true;
              }
          }).catch(function (error) {
              console.log('error=============>', error);
          });
          return flag;
        },
        async goods_use_click(index, goods_type) {
          if(this.doubleSubmit)
            return;
          this.doubleSubmit = true
          let checkLock = await this.lock_extention();
          if(!checkLock)
            return;
            var extention_flag = this.$store.getters['getExtention_flag'];
            if (goods_type == 'goods') {
                if (!extention_flag.value) {
                    if (!common.use_good_check(this.my_seat_product_list, index)) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `<span>이미 같은 종류의 상품을 이용중입니다</span>.<br><span>해당 상품을 선택해 주세요.</span> `,
                            router: '/',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.doubleSubmit = false
                        return;
                    }
                }
            } else {
                if (!extention_flag.value) {
                    if (this.my_coupon_list.length > 0) {
                        if (!common.use_good_check(this.my_coupon_list, index)) {
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `<span>이미 같은 종류의 상품을 이용중입니다</span>.<br><span>해당 상품을 선택해 주세요.</span> `,
                                router: '/',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            this.doubleSubmit = false
                            return;
                        }
                    }
                }
            }

            var seat_data = this.$store.getters['get_select_seat'];
            let request_data = new Object;

            if (goods_type === 'goods') {
                if(this.my_seat_product_list[index].seat_m_use_yn === 0 || this.my_seat_product_list[index].event_m_use_yn === 0){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `해당상품은 모바일에서 사용이 불가능한 상품입니다.`,
                        router: '',
                        image_type: 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.doubleSubmit = false
                    return;
                }
                /*if (this.my_seat_product_list[index].day_count_yn == 1) { //기간권 속성 아이템은 사용 불가 dg0602
                  const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `<span>해당 상품은 키오스크에서만 이용하실 수 있습니다.</span>`,
                    router: '',
                    image_type: 'warning'
                  };
                  this.$store.commit('set_popup_type', alert_param);
                  return;
                }*/
                // 선택한 상품이 주야간 권일경우 해당상품을 현재 사용할수있는 시간인지 아닌지를 처리하는 로직
                if (this.my_seat_product_list[index].day_count_yn == 1 && this.my_seat_product_list[index].time_zone_yn == 1 && this.my_seat_product_list[index].hours_yn == 0) {
                    //250612 주야간권 자정 넘은 시간이 고려되지 않아 수정함..
                    const now = new Date();
                    const nowMinutes = now.getHours() * 60 + now.getMinutes();
                    let isValid = false;
                    
                    const seatProduct = this.my_seat_product_list[index];
                    const [startHour, startMin] = seatProduct.start_time.split(':').map(Number);
                    const [endHour, endMin] = seatProduct.end_time.split(':').map(Number);
                    let startMinutes = startHour * 60 + startMin;
                    let endMinutes = endHour * 60 + endMin;

                    // 자정 처리 (00:00 → 1440)
                    if (endMinutes === 0) endMinutes = 1440;

                    // 일반 구간
                    if (startMinutes < endMinutes) {
                        isValid = startMinutes <= nowMinutes && nowMinutes < endMinutes;
                    }
                    // 자정 넘김 구간
                    else {
                        isValid = nowMinutes >= startMinutes || nowMinutes < endMinutes;
                    }
                    if (!isValid) {
                        this.$store.commit('set_popup_type', {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `상품의 시작시간 이후에 선택 가능합니다.`,
                            router: '',
                            image_type: 'warning'
                        });
                        this.doubleSubmit = false;
                        return;
                    }
                    /* 250612 수정전
                    var tDate = new Date();

                    tDate.setDate(tDate.getDate() + this.my_seat_product_list[index].day_count);
                    var dd = tDate.getDate();
                    var mm = tDate.getMonth() + 1; //January is 0!
                    var yyyy = tDate.getFullYear();
                    var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
                    var h = tDate.getHours();
                    var m = tDate.getMinutes();
                    if (h < 10) h = '0' + h;
                    if (m < 10) m = '0' + m;

                    let time = h + ':' + m;

                    if (!(this.my_seat_product_list[index].start_time <= time && this.my_seat_product_list[index].end_time > time)) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `상품의 시작시간 이후에 선택 가능합니다.`,
                            router: '',
                            image_type: 'warning'
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.doubleSubmit = false
                        return;
                    }
                    */
                }



                if (this.my_seat_product_list[index].hours_yn == 1 && this.my_seat_product_list[index].end_time_yn == 1) {
                    var start_date = this.$moment(this.my_seat_product_list[index].startDate_for_receipt);
                    var end_date = '';
                    if (this.my_seat_product_list[index].use_end_datetime == null) {
                        end_date = this.$moment().add(this.my_seat_product_list[index].left_time - 1, 'minutes');
                    } else {
                        end_date = this.$moment(this.my_seat_product_list[index].use_end_datetime);
                    }
                    this.my_seat_product_list[index].use_hours_plan = end_date.diff(start_date, 'minutes') + 1;
                } else {
                    this.my_seat_product_list[index].use_hours_plan = this.my_seat_product_list[index].left_time;

                }
                // let hour = new Date().setMinutes(new Date().getMinutes() + this.my_seat_product_list[index].left_time);
                // this.my_seat_product_list[index].use_end_datetime = this.date_format(hour);
                this.my_seat_product_list[index].seat_id = seat_data[0].seat_id;
                request_data.data = this.my_seat_product_list[index];
                //북마크

                if (this.my_seat_product_list[index].day_count_yn === 1 && this.my_seat_product_list[index].time_zone_yn === 0 && this.my_seat_product_list[index].hours_yn === 0) {
                    for (let i = 0; i < this.my_seat_product_list.length; i++) {
                        if (!this.season_flag && this.my_seat_product_list[i].day_count_yn === 1 && this.my_seat_product_list[i].time_zone_yn === 0 && this.my_seat_product_list[i].hours_yn === 0 && this.my_seat_product_list[i].name == '사용중') {
                            this.season_alert = true;
                            this.rem_index = index;
                            return;
                        }
                    }
                }
            } else if (goods_type === 'coupon') {
                if(this.my_coupon_list[index].coupon_m_use_yn === 0){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `해당상품은 모바일에서 사용이 불가능한 상품입니다.`,
                        router: '',
                        image_type: 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.doubleSubmit = false
                    return;
                }else{
                }
                /*
                if (this.my_coupon_list[index].day_count_yn == 1) { //기간권 속성 아이템은 사용 불가 dg0602
                  const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `<span>해당 상품은 키오스크에서만 이용하실 수 있습니다.</span>`,
                    router: '',
                    image_type: 'warning'
                  };
                  this.$store.commit('set_popup_type', alert_param);
                  return;
                }*/
                // 선택한 상품이 주야간 권일경우 해당상품을 현재 사용할수있는 시간인지 아닌지를 처리하는 로직
                if (this.my_coupon_list[index].day_count_yn == 1 && this.my_coupon_list[index].time_zone_yn == 1 && this.my_coupon_list[index].hours_yn == 0) {
                    //250612 주야간권 자정 넘은 시간이 고려되지 않아 수정함..
                    const now = new Date();
                    const nowMinutes = now.getHours() * 60 + now.getMinutes();
                    let isValid = false;
                    
                    const coupon = this.my_coupon_list[index];
                    const [startHour, startMin] = coupon.start_time.split(':').map(Number);
                    const [endHour, endMin] = coupon.end_time.split(':').map(Number);
                    let startMinutes = startHour * 60 + startMin;
                    let endMinutes = endHour * 60 + endMin;

                    // 자정 처리 (00:00 → 1440)
                    if (endMinutes === 0) endMinutes = 1440;

                    // 일반 구간
                    if (startMinutes < endMinutes) {
                        isValid = startMinutes <= nowMinutes && nowMinutes < endMinutes;
                    }
                    // 자정 넘김 구간
                    else {
                        isValid = nowMinutes >= startMinutes || nowMinutes < endMinutes;
                    }

                    if (!isValid) {
                        this.$store.commit('set_popup_type', {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `상품의 시작시간 이후에 선택 가능합니다.`,
                            router: '',
                            image_type: 'warning'
                        });
                        this.doubleSubmit = false;
                        return;
                    }

                    /* 250612 수정전 
                    var tDate = new Date();

                    tDate.setDate(tDate.getDate() + this.my_coupon_list[index].end_day_count);
                    var dd = tDate.getDate();
                    var mm = tDate.getMonth() + 1; //January is 0!
                    var yyyy = tDate.getFullYear();
                    var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
                    var h = tDate.getHours();
                    var m = tDate.getMinutes();
                    if (h < 10) h = '0' + h;
                    if (m < 10) m = '0' + m;

                    let time = h + ':' + m;
                    if (!(this.my_coupon_list[index].start_time <= time && this.my_coupon_list[index].end_time > time)) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `상품의 시작시간 이후에 선택 가능합니다.`,
                            router: '',
                            image_type: 'warning'
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.doubleSubmit = false
                        return;
                    }
                    */
                }

                this.my_coupon_list[index].use_hours_plan = this.my_coupon_list[index].left_time;
                // let hour = new Date().setMinutes(new Date().getMinutes() + this.my_coupon_list[index].left_time);
                // this.my_coupon_list[index].use_end_datetime = this.date_format(hour);
                this.my_coupon_list[index].seat_id = seat_data[0].seat_id;
                request_data.data = this.my_coupon_list[index];

            }

            if (this.continue_seat_purchase_history_flag) {
                var chk_flag = false;
                for (let i = 0; i < this.my_seat_product_list.length; i++) {
                    if (this.already_continue_seat_purchase_history_id == this.my_seat_product_list[i].seat_purchase_history_id) {
                        chk_flag = true;
                        this.already_exten_seat_item_name = this.my_seat_product_list[i].goods_group_name;
                        this.already_exten_seat_item_time = this.my_seat_product_list[i].goods_time;
                    }
                }
                if (!chk_flag) {
                    for (let i = 0; i < this.my_coupon_list.length; i++) {
                        if (this.already_continue_seat_purchase_history_id == this.my_coupon_list[i].seat_purchase_history_id) {
                            chk_flag = true;
                            this.already_exten_seat_item_name = this.my_coupon_list[i].goods_group_name;
                            this.already_exten_seat_item_time = this.my_coupon_list[i].goods_time;
                        }
                    }
                }
            }
            this.request_data_info = request_data;

            this.exten_seat_item_name = this.request_data_info.data.goods_group_name;
            this.exten_seat_item_time = this.request_data_info.data.goods_time;

            if (this.seat_use_txt_flag) {
                this.popup_code = 101;
            } else {
                var nowDate = this.$moment().format("YYYY-MM-DD HH:mm:00");

                request_data.data.startDate_for_receipt = nowDate;
                request_data.data.exten_yn = false;
                
                const type = config.REQ_SEAT_USE_INSERT;
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: request_data
                }).then(response => {
                    if (response.message == "complete") {

                        var store_pay_info = this.$store.getters['getStore_pay_info'];
                        if (!store_pay_info) {
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `좌석이 점유되었습니다.`,
                                router: '',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                        }

                        this.modal_close();
                        this.$store.commit('set_seat_move_flag', !this.$store.getters.get_seat_move_flag);

                    }
                    this.$store.commit('set_seat_move_step', 6);
                    this.$store.commit('set_Item_update_check', {
                        item_id: seat_data[0].seat_id,
                        item: 'seat',
                        last_status: 'using'
                    });
                    this.$store.state.seat_type_color.seat_using_count++
                    this.doubleSubmit = false;
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
        },
        use_extention_ask_for_check() {
            var request_data = this.request_data_info;
            var extention_flag = this.$store.getters['getExtention_flag'];

            if (this.seat_use_txt_flag) {
                // var nowDate = this.$moment().format("YYYY-MM-DD hh:mm:00");
                // request_data.startDate_for_receipt = nowDate;
                request_data.data.exten_yn = true;
                const type = config.REQ_SEAT_USE_UPDATE;
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: request_data
                }).then(response => {
                    if (response.message == "complete") {
                        //this.popup_code = 26  // 영수증 출력
                        this.modal_close();
                        this.$store.commit('set_seat_move_flag', !this.$store.getters.get_seat_move_flag);
                    }
                    this.$store.commit('set_seat_move_step', 6);
                    this.$store.commit('set_Item_update_check', {
                        item_id: request_data.data.seat_id,
                        item: 'seat',
                        last_status: 'using'
                    });
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            } else {

            }
        },
        season_chk() {
            this.season_alert = false;
            this.season_flag = true;
            this.goods_use_click(this.rem_index, 'goods');
        },
        groom_goods_use_click_timecover(index,data){
            this.exten_groom_index = index;
            this.choice_use_time = 0;
            this.choice_use_time_left_list = [];
            this.left_time_for_send_server = data.left_hours;
            var remainder_chk;
            var array_length = data.left_hours / 60;

            for (let i = 0; i < Math.floor(array_length); i++) {
                var time = i + 1;
                this.choice_use_time_left_list.push(time + "시간");
            }

            remainder_chk = Number.isInteger(array_length);
            array_length = Math.floor(array_length);

            if(!remainder_chk){
                this.choice_use_time_left_list.push('남은시간 모두사용');
            }

            this.choice_use_time = this.choice_use_time_left_list[0]; // defalut 값 셋팅

            this.popup_code = 102;
        },
        /**
         * 그룹룸 시간충전권사용
         */
        groom_goods_use_click(index) {
            var exten_flag = '0';
            var groom_use_id = '';
            //var groom_data = this.$store.getters['get_my_groom_data'];
            var selec_groom_data =  this.$store.getters['get_select_groom'];
            var use_end_datetime; // groom_use table 의 use end date time 을 담을 변수

            for (let i = 0; i < this.exten_groom_data.length; i++) {
                if (this.exten_groom_data[i].groom_id == groom_data[0].groom_id && this.exten_groom_data[i].groom_use_id == groom_data[0].groom_use_id) {
                    exten_flag = '1';
                    use_end_datetime = this.exten_groom_data[i].use_end_datetime;
                }
            }

            let request_data = new Object;
            if (index == 'index_not_use') {
                request_data.data = this.my_groom_product_list[this.exten_groom_index];
                let time_setting;
                if(this.choice_use_time === '남은시간 모두사용') {
                    time_setting = request_data.data.left_hours
                    request_data.data.use_hours = time_setting
                } else {
                    time_setting = this.choice_use_time.replace('시간', '')
                    request_data.data.use_hours = time_setting * 60
                }
            } else {
                request_data.data = this.my_groom_product_list[index];
            }
            var nowDate = this.$moment().format("YYYY-MM-DD HH:mm:00");
            request_data.data.startDate_for_receipt = nowDate;

            let type;
            if (exten_flag == 0) {
                // 이용연장이 아닌 그룹룸 첫등록
                type = config.REQ_GROOM_USE_INSERT;
            } else {
                //이용연장
                request_data.data.use_end_datetime = use_end_datetime;
                request_data.data.groom_use_id = groom_data[0].groom_use_id;

                if (request_data.data.selection_plan_code == null) {
                    var str = '';
                    var str_array;
                    str = this.choice_use_time;
                    str_array = str.split('시간');
                    var flag = false;

                    if (str_array[0] == '남은') {
                        this.choice_use_time = this.left_time_for_send_server;
                    } else {
                        this.choice_use_time = Number(str_array[0]) * 60;
                    }
                    request_data.data.use_hours = this.choice_use_time;
                }
                type = config.REQ_GROOM_USE_UPDATE; // 업뎃으로 변경
            }

            const startDispatch = () => {
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: request_data
                }).then(response => {
                    if (response.message == "complete") {
                        console.log('b');
                        this.modal_close();
                        this.$store.commit('set_groom_move_step', 6);
                        this.$store.commit('set_Item_update_check', {
                            item_id: groom_data[0].groom_id,
                            item: 'groom',
                            last_status: 'using'
                        });
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            };

            // 예약이 있는지 검사
            const groom_reserv_check = config.REQ_GROOM_RESERV_CHECK
            this.$store.dispatch(groom_reserv_check.action_name, {
                type: groom_reserv_check,
                data: {
                    'use_hours': request_data.data.use_hours,
                    'groom_id': request_data.data.groom_id,
                    'exflag': exten_flag
                }
            }).then(response => {
                let count = response.data[0].count;
                if (count > 0) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `해당 시간에 예약내역이 있습니다.`,
                        router: '',
                        image_type: 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param)
                    this.$store.commit('set_groom_move_step', 1);
                    return;
                } else {
                    if (this.$store.getters.get_store_option.groom_limit_now_use == 'Y') {
                        let check_use_now = true;
                        let today = "";
                        
                        const processTimeCheck = (today) => {
                            let use_start_time = today == "" ? this.$moment() : this.$moment(today);
                            let use_end_time = this.$moment().add(request_data.data.use_hours, 'minutes');
                            //let limit_now_start_time = this.$store.getters.get_store_option.groom_limit_now_start_time*1;
                            //let limit_now_end_time = this.$store.getters.get_store_option.groom_limit_now_end_time*1;
                            let limit_now_start_time = this.$moment(this.$moment().format('YYYY-MM-DD')).add(this.$store.getters.get_store_option.groom_limit_now_start_time, 'hours');
                            // 250710 Number 추가
                            let limit_now_end_time = Number(this.$store.getters.get_store_option.groom_limit_now_start_time) < Number(this.$store.getters.get_store_option.groom_limit_now_end_time) 
                            ? this.$moment(this.$moment().format('YYYY-MM-DD')).add(this.$store.getters.get_store_option.groom_limit_now_end_time*1, 'hours')
                            : this.$moment(this.$moment().format('YYYY-MM-DD')).add(this.$store.getters.get_store_option.groom_limit_now_end_time*1, 'hours').add(1, 'days');

                            if ((use_start_time.isBefore(limit_now_start_time) && use_end_time.isAfter(limit_now_start_time)) ||
                                (use_start_time.isSameOrAfter(limit_now_start_time) && use_start_time.isBefore(limit_now_end_time))) {
                                check_use_now = false;
                            }


                            // 그룹룸 사용 불가능한 시간일 경우 경고
                            if (!check_use_now) {
                                const alert_param = {
                                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                    message: `그룹룸 즉시사용이 불가한 시간입니다.`,
                                    router: '',
                                    image_type: 'warning'
                                };
                                this.$store.commit('set_popup_type', alert_param)
                                this.$store.commit('set_groom_move_step', 1);
                                return;
                            }
                        };

                        if (exten_flag == 1) {
                            this.groomUseInfoCheck(request_data.data.groom_id).then(useEndDatetime => {
                                today = new Date(useEndDatetime + ":00");  
                                processTimeCheck(today); 
                                if (check_use_now) {
                                    startDispatch();  
                                }
                            });
                        } else {
                            //today = new Date(); 
                            processTimeCheck(today); 
                            if (check_use_now) {
                                    startDispatch();  
                                }
                        }
                    }else{
                        startDispatch();  
                    }
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },

        groomOptionCheck(){
            const reserv_type = config.REQ_STORE_OPTION;
            this.$store.dispatch(reserv_type.action_name, {
                type: reserv_type,
                data: {'store_id':this.$store.getters['getStoreId']}
            }).then(response => {
                console.log(response.data)
                 this.groom_limit_now_use = response.data.groom_limit_now_use;
                 this.groom_limit_now_start_time = response.data.groom_limit_now_start_time;
                 this.groom_limit_now_end_time = response.data.groom_limit_now_end_time; 
                  
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },        
        async groomUseInfoCheck(val){
        // 그룹룸 로직 상품 추가
            const type = config.REQ_GROOM_USE_SELECT;
            var user_data = this.$store.getters['getUser'];
            var roomreturn = '';
            const data = {
                'user_id': user_data.user_id,
                'groom_id': val
            };

            return this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                console.log(response.data[0].use_end_datetime)
                //this.groom_info = response.data;
                return response.data[0].use_end_datetime; 
                //roomreturn = response.data[0].use_end_datetime;
            }).catch(function (error) {
                console.log('error=============>', error);
            });
            
        },
        date_format(hour) {
            let tDate = new Date(hour);
            var dd = tDate.getDate();
            var mm = tDate.getMonth() + 1; //January is 0!
            var yyyy = tDate.getFullYear();
            var h = tDate.getHours();
            var m = tDate.getMinutes();
            if (h < 10) {
                h = '0' + h;
            }
            if (m < 10) {
                m = '0' + m;
            }
            var currentTime_server = h + ':' + m + ':' + '00';
            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }
            return yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;
        },
        close_move_seat() {
            if(this.$store.getters.get_last_url == "/barcode"){
                this.$store.commit('set_reset_popup_type');
            }else{
                this.popup_code = 11
            }
        },
        close_move_locker() {
            this.popup_code = 12
        },
        reservation_number_input(type_num) {
            if (type_num == 'del') {
                if (this.reservation_number.length != 0) {
                    this.reservation_number = this.reservation_number.substr(0, this.reservation_number.length - 1);
                }
            } else {
                if (this.reservation_number.length <= 7) {
                    this.reservation_number = this.reservation_number + type_num;
                } else {
                    return false;
                }
            }
        },
        resev_num_comfirm() {
            if (this.reservation_number.length === 8) {
                const type = config.REQ_RESERVATION_NUMBER_CONFIRM;

                const data = {
                    'reserv_number': this.reservation_number,
                };
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    let res_vo = response;
                    if (res_vo.message === 'exist') {
                        // 결제완료인 경우
                        if (res_vo.status === 'complete') {
                            // 출입문 열기 호출
                            const type = config.REQ_GROOM_PASS_GET_INFO;

                            const data = {
                                'groom_reservation_id': res_vo.data[0].groom_reservation_id,
                            };
                            this.$store.dispatch(type.action_name, {
                                type: type,
                                data: data
                            }).then(response => {
                                var store_data = this.$store.getters['getStoreInfo'];
                                var dataset = {};
                                // var receipt_setting = {
                                //   RECEIPT_ADDR : 1,
                                //   RECEIPT_ADMIN_NAME : 1,
                                //   RECEIPT_BARCODE: 1,
                                //   RECEIPT_CORP_NO : 1,
                                //   RECEIPT_COST : 0,
                                //   RECEIPT_START_DATE : 1,
                                //   RECEIPT_END_DATE : 1,
                                //   RECEIPT_EXPIRED_DATE : 0,
                                //   RECEIPT_GOOD_NAME : 0,
                                //   RECEIPT_PAY_INFO : 0,
                                //   RECEIPT_PRINT_DATE : 1,
                                //   RECEIPT_SEAT_NAME : 1,
                                //   RECEIPT_STORE_HP : 1,
                                //   RECEIPT_STORE_NAME : 1,
                                //   RECEIPT_USER_NAME : 1,
                                //   RECEIPT_WIFI : 1
                                // }
                                // this.$store.commit('set_receipt_setting_detail', "groom_reservation");
                                dataset.userName = response.data.name;
                                dataset.payment_seat_name = '그룹룸   명'; // 좌석 이름
                                dataset.seatName = response.data.groom_name; // 좌석명
                                dataset.startDate = response.data.use_start_datetime; // 시작 시간
                                dataset.endDate = response.data.endDate + ':00'; // 종료 시간
                                dataset.barcode_number = response.data.barcode_code; // 바코드 번호
                                // dataset.receipt_setting = receipt_setting;   // 프린트 세팅
                            })

                            // 미결제인 경우
                        } else if (res_vo.status === 'notPay') {
                            this.$store.commit('set_reservation_info', res_vo.data[0]);
                            this.$store.commit('set_groom_reservation_pay', true);
                            if (!this.$store.state.login_chk) {
                                this.$store.commit('set_Last_URL', '/');
                                // this.$router.push('/login');
                            } else {
                                // this.$router.push('/Payment_reservation');

                                this.$router.push('/');
                            }
                        }
                        this.modal_close();
                    } else if (res_vo.message === 'none') {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `예약번호가 유효하지 않습니다.\n확인 후 다시 입력 바랍니다.`,
                            router: null,
                        };
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (res_vo.message === 'not_yet') {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `예약시간 30분 전부터 출입증 출력이 가능 합니다.`,
                            router: null,
                        };
                        this.$store.commit('set_popup_type', alert_param);
                    }

                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
            this.reservation_number = '';
        },
        doorOpen(tid) {
            let data = this.$store.getters["get_door_kind_list"][tid];
            let urlString = '';

            switch (data.kind) {
                case "0":
                    urlString = "/door/CNC?tid=" + data.tid;
                    break;
                case "1":
                    urlString = "/door/IS?tid=" + data.tid;
                    break;
            }

            axios.get(urlString).then(result => {
                let textString = '';
                switch (result.data.res) {
                    case "none":
                        textString = "코드 오류 - 관리자 문의";
                        break;
                    case "error":
                        textString = "컨트롤러 오류 - 관리자 문의";
                        break;
                    case "open":
                        textString = "자동문이 정상적으로 열렸습니다.";
                        break;
                }
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: textString,
                    router: null,
                };
                this.$store.commit('set_popup_type', alert_param);
                this.$router.push("/start");

                let self = this;
                setTimeout(function () {
                    self.$store.commit('set_reset_popup_type')
                }, 3000);
            });
        },
        go_reservation_pay() {
            this.$router.push('/Payment_reservation');
            this.modal_close();
        },
        barcodeEncoding(barcode) {
            let iv = Buffer.from(config.IV);
            let key = Buffer.from(config.ENCRYPTION_KEY);
            let cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
            let encrypted = cipher.update(barcode);
            encrypted = Buffer.concat([encrypted, cipher.final()]);
            return encrypted.toString('base64');
        },
        seat_barcode_view() {
            var seat_info = this.$store.getters['get_my_seat_data'][0];
            var barcode_number = this.$store.getters['get_seat_barcode'];
            var dataset = {};

            dataset.payment_seat_name = '좌석　이름'; // 좌석 이름
            dataset.seatName = seat_info.seat_name; // 좌석명
            dataset.storeId = this.$store.getters['getStoreId'];
            //dataset.endDate = this.$moment(seat_info.use_end_datetime).format('YYYY-MM-DD HH:mm:00');   // 종료 시간
            dataset.barcode_number = barcode_number; // 바코드 번호

            this.barcode_value = barcode_number;
            this.popup_code = 105;

        },
        groom_barcode_view() {
            var seat_info = this.$store.getters['get_my_groom_data'][0];
            var barcode_number = this.$store.getters['get_groom_barcode'];
            var dataset = {};

            dataset.payment_seat_name = '좌석　이름'; // 좌석 이름
            dataset.seatName = seat_info.groom_name; // 좌석명
            dataset.endDate = this.$moment(seat_info.use_end_datetime).format('YYYY-MM-DD HH:mm:00'); // 종료 시간
            dataset.barcode_number = barcode_number; // 바코드 번호

            this.barcode_value = barcode_number;
            this.popup_code = 105;

            // this.modal_close();
        },
        confirm() {
            this.$store.commit('set_reset_popup_type');
            this.modal_close();
            // this.$router.push('/');
        },
        get_groom_reservation_data(data) {
            this.mygroom_using = data.using;
            this.mygroom_reser = data.reser;
            this.mygroom_reser.index = this.mygroom_using.length;
        },
        can_not_continue() {
          const alert_param = {
            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
            message: "사용하지 않은 상품으로만 이용연장 할 수 있습니다",
            router: null,
          };
          this.$store.commit('set_popup_type', alert_param);
          return;
        },
        tab_select(kind){
            this.tab_kind = kind;
        },
        decodeHtmlEntities(text) {
            if (!text) return '';
            return text
                .replace(/\n/g, '<br>')
                .replace(/&lt;br\s*\/?&gt;/gi, '<br>')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'")
                .replace(/&amp;/g, '&');
        }
    
    },
    created () {
        EventBus.$on('floor_tab', () => {
            this.seat_flag = !this.seat_flag;
            this.tab_data = this.$store.getters['get_map_group_list'];

            const type = config.REQ_SEAT_USER_GET_TYPE_COLOR_LIST;
            const req_data = {
                map_group_id: this.tab_data[0].map_group_id
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: req_data
            }).then(response => {
                this.$store.commit('set_seat_type_color', response.data);
                this.seat_type_color = response.data
            }).catch(function (error) {
                console.log('error=============>', error);
            });

            this.floor_tab(this.tab_data[0], 0);
        });
    },
    computed: {
        get_popup_code() {
            return this.$store.getters.get_popup_type.code;
        },
        get_tab_kind() {
            return this.tab_kind;
        },
    },
    watch: {
        get_popup_code(val, OldVal) {
            this.popup_code = val;
            this.message = this.$store.getters.get_popup_type.message;
            this.router = this.$store.getters.get_popup_type.router;
            this.image_type = this.$store.getters.get_popup_type.image_type;
            this.guide_data = this.$store.getters.get_popup_type.data; //250519 추가

            // 메인페이지에서 좌석이동가능하게 하기위해
            if (val == 5) {
                var seat_info = this.$store.getters['get_main_page_update_seat'];
                if (seat_info != null) {
                    this.move_seat_id = seat_info.sel_seat_id;
                    this.move_seat_name = seat_info.sel_seat_name;
                    // 스토어에서 가져온 my seat use id 를 저장함
                    this.sel_seat_use_id = seat_info.my_seat_use_id;
                    this.sel_seat_id = seat_info.my_seat_id;
                }
            }
            if (val == 7) {
                var use_end_info = this.$store.getters.get_use_end_info;
                this.sel_seat_id = use_end_info.seat_id;
                this.sel_seat_use_id = use_end_info.seat_use_id;
                this.seat_left_time = use_end_info.seat_left_time;
                this.seat_use_end_time = use_end_info.seat_use_end_time;
                this.seat_expire_time = use_end_info.seat_expire_time;
            }
            // 내 좌석 클릭시 나오는 팝업
            if (val == 11 || val == 19) {
                var exten_day_count;
                var exten_left_time;
                var exten_goods_group_name;
                var exten_use_time_setting_yn;

                // 내좌석 정보 세팅
                this.seat_purchase_history_id = ''; // seat use table 의 history 아이디 초기화 ()
                var my_seat_data = this.$store.getters['get_my_seat_data'];
                this.seat_info = my_seat_data;
                this.use_good_endtime = this.seat_info[0].use_end_datetime;

                var user_data = this.$store.getters['getUser'];

                const my_info_data = {
                    'user_id': user_data.user_id,
                    'seat_id': this.$store.getters['get_select_seat'][0].seat_id,
                    'seat_type_code': this.$store.getters['get_select_seat'][0].seat_type_code
                };

                const request_data = {
                    data: {}
                };
                //연장로직인지 파악
                var ex_flg = this.$store.getters['getExtention_flag'];
                this.extention_flag = ex_flg.value;

                const seat_use_type = config.REQ_SEAT_USE_GET_LIST;

                this.$store.dispatch(seat_use_type.action_name, {
                    type: seat_use_type,
                    data: request_data
                }).then(response => {
                    
                    if (response.data.length > 0) {
                        this.seat_use_txt_flag = true;
                        if (response.data[0].day_count == null) {
                            this.time_goods_flag = 1
                        } else {
                            this.time_goods_flag = 0
                        }
                        this.seat_purchase_history_id = response.data[0].seat_purchase_history_id;
                        if (response.data[0].continue_seat_purchase_history_id != null) {
                            this.already_continue_seat_purchase_history_id = response.data[0].continue_seat_purchase_history_id;
                            this.already_exten_seat_item_time = response.data[0].continue_use_hours_plan;
                            this.continue_seat_purchase_history_flag = true;

                            const exten_item_info = config.REQ_MY_SEAT_EXTENGOODS_GET_INFO;
                            const exten_item_data = {
                                seat_purchase_history_id: this.already_continue_seat_purchase_history_id
                            };
                            this.$store.dispatch(exten_item_info.action_name, {
                                type: exten_item_info,
                                data: exten_item_data
                            }).then(response => {
                                exten_day_count = response.data[0].day_count;
                                exten_left_time = response.data[0].left_time;
                                exten_goods_group_name = response.data[0].goods_group_name;
                                exten_use_time_setting_yn = response.data[0].use_time_settings_yn;
                            }).catch(function (error) {
                                console.log('error=============>', error);
                            });
                        } else {
                            this.continue_seat_purchase_history_flag = false;
                        }
                        this.seat_use_hours_plan = response.data[0].use_hours_plan;
                    } else {
                        this.seat_use_txt_flag = false;
                    }

                }).catch(function (error) {
                    console.log('error=============>', error);
                });

                // 내 좌석 상품목록

                const myproduct_list_type = config.REQ_MYPAGE_SEAT_GOODS_GET_LIST;
                // 내 쿠폰목록
                const mycoupon_list_type = config.REQ_MYPAGE_COUPON_GOODS_GET_LIST;

                let seat_use_purchase_id = null;
                // 사용중인 좌석 남은 시간 조 회
                const seat_use_left_time_update = config.REQ_SEAT_USE_LEFT_TIME;
                this.$store.dispatch(seat_use_left_time_update.action_name, {
                    type: seat_use_left_time_update,
                    data: {}
                }).then(response => {
                    seat_use_purchase_id = response.data.seat_purchase_history_id;
                    Promise.all(
                        [
                            this.$store.dispatch(myproduct_list_type.action_name, {
                                type: myproduct_list_type,
                                data: my_info_data
                            }),
                            this.$store.dispatch(mycoupon_list_type.action_name, {
                                type: mycoupon_list_type,
                                data: my_info_data
                            }),
                        ]
                    ).then(responseList => {
                        // 응답 - 요청 순서별 응답 array
                        let my_seat_splice_arr = [];
                        let coupon_seat_splice_arr = [];
                        this.my_seat_product_list = responseList[0].data;
                        this.my_seat_product_list.sort((a,b) => {
                          return a.code < b.code ? -1 : a.code > b.code ? 1 : 0;
                        })
                        // 좌석이동 제한 체크시
                            if(response.data.seat_move_check == '1'){
                                this.seat_move_flag = true;
                            }else{
                                this.seat_move_flag = false; 
                            }

                        // 당일권 연장불가할때 
                        if(response.data.ets_time_check == '1'){
                            // 일일시간권일때
                            if(response.data.time_zone_yn == 0 && response.data.day_count_yn  == 0 && response.data.hours_yn == 1 && response.data.end_term_yn == 0){
                                this.time_continue_flag = true;
                            }else{ 
                                this.time_continue_flag = false;
                            }
                        }else{ 
                            this.time_continue_flag = false; 
                        } 
                         
                        // 응답 - 요청 순서별 응답 array
                        for (var i = 0; i < this.my_seat_product_list.length; i++) {
                            if (this.continue_seat_purchase_history_flag) { // 연장상품이 있다면 ,

                                //if (this.already_continue_seat_purchase_history_id == this.my_seat_product_list[i].seat_purchase_history_id) { // 연장상품의 id와 내가가지고 있는 상품의 id가 같다면,
                                this.useinfo_exten_seat_item_name = exten_goods_group_name;

                                if (exten_use_time_setting_yn == 1) { // 시간사용설정 여부가 y 인 상품이라면,

                                    // 시간계산 로직 (해당 좌석의 종료시간에 맞추어 연장등록된 use hours plan 값을 이용해 예상종료시간을 계산)
                                    let time = new Date(this.seat_info[0].use_end_datetime).setMinutes(new Date(this.seat_info[0].use_end_datetime).getMinutes() + this.already_exten_seat_item_time);
                                    let tDate = new Date(time);

                                    let dd = tDate.getDate();
                                    let mm = tDate.getMonth() + 1; //January is 0!
                                    let yyyy = tDate.getFullYear();
                                    let hour = tDate.getHours();
                                    let min = tDate.getMinutes();
                                    if (hour < 10) {
                                        hour = '0' + hour;
                                    }
                                    if (min < 10) {
                                        min = '0' + min;
                                    }

                                    if (dd < 10) {
                                        dd = '0' + dd;
                                    }
                                    if (mm < 10) {
                                        mm = '0' + mm;
                                    }
                                    let currentTime = hour + ":" + min + "";
                                    this.useinfo_exten_seat_item_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;

                                    var pic_time = this.already_exten_seat_item_time;
                                    if ((pic_time / 60) % 1 === 0) {
                                        this.useinfo_exten_seat_use_our_plan = (pic_time / 60) + '시간';
                                    } else {
                                        var min;
                                        min = pic_time % 60;
                                        pic_time = pic_time - min;
                                        this.useinfo_exten_seat_use_our_plan = (pic_time / 60) + '시간 ' + min + '분';
                                    }

                                } else {
                                    let time;
                                    if (exten_left_time > 0) {
                                        time = new Date(this.seat_info[0].use_end_datetime).setMinutes(new Date(this.seat_info[0].use_end_datetime).getMinutes() + exten_left_time);
                                    } else {
                                        time = new Date(this.seat_info[0].use_end_datetime).setDate(new Date(this.seat_info[0].use_end_datetime).getDate() + exten_day_count);
                                    }

                                    let tDate = new Date(time);
                                    let dd = tDate.getDate();
                                    let mm = tDate.getMonth() + 1; //January is 0!
                                    let yyyy = tDate.getFullYear();
                                    let hour = tDate.getHours();
                                    let min = tDate.getMinutes();
                                    if (hour < 10) {
                                        hour = '0' + hour;
                                    }
                                    if (min < 10) {
                                        min = '0' + min;
                                    }

                                    if (dd < 10) {
                                        dd = '0' + dd;
                                    }
                                    if (mm < 10) {
                                        mm = '0' + mm;
                                    }
                                    let currentTime = hour + ":" + min + "";
                                    this.useinfo_exten_seat_item_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
                                    if (this.already_exten_seat_item_time > 0) {
                                        var pic_time = this.already_exten_seat_item_time;
                                        if ((pic_time / 60) % 1 === 0) {
                                            this.useinfo_exten_seat_use_our_plan = (pic_time / 60) + '시간';
                                        } else {
                                            var min;
                                            min = pic_time % 60;
                                            pic_time = pic_time - min;
                                            this.useinfo_exten_seat_use_our_plan = (pic_time / 60) + '시간 ' + min + '분';
                                        }
                                    } else {
                                        this.useinfo_exten_seat_use_our_plan = this.useinfo_exten_seat_item_time;
                                    }
                                }
                                //  }

                            }

                            if (val == 19 && (seat_use_purchase_id === this.my_seat_product_list[i].seat_purchase_history_id) && this.my_seat_product_list[i].use_time_settings_yn === 0 && this.extention_flag) {
                                my_seat_splice_arr.push(i);
                            }
                            if (this.my_seat_product_list[i].seat_purchase_history_id === seat_use_purchase_id) {
                                this.seat_left_time = response.data.minute;
                            }
                            // 당일권의 경우
                            if (this.my_seat_product_list[i].day_count_yn == 0 && this.my_seat_product_list[i].hours_yn == 1 && this.my_seat_product_list[i].time_zone_yn == 0 && this.my_seat_product_list[i].end_time_yn == 1) {
                                if (this.my_seat_product_list[i].name != "사용전") {
                                    this.my_seat_product_list[i].click_yn = false;
                                    var time_type = this.my_seat_product_list[i].time_type;
                                    var end_date = this.my_seat_product_list[i].use_end_datetime;
                                    var use_start_date = this.$moment();
                                    var use_end_date = this.$moment(end_date);
                                    var left_time = use_end_date.diff(use_start_date, 'minutes') + 1;
                                    var date_time = this.my_seat_product_list[i].seat_purchase_history_id === seat_use_purchase_id ?
                                        this.timeToDateTime(left_time, time_type, end_date) : this.timeToDateTime(left_time, time_type, end_date);
                                    this.my_seat_product_list[i].str_left_time = date_time;

                                }
                            } else if (this.my_seat_product_list[i].day_count_yn == 0 && this.my_seat_product_list[i].hours_yn == 1 && this.my_seat_product_list[i].time_zone_yn == 0) {
                                // 시간권인 경우

                                this.my_seat_product_list[i].click_yn = false;
                                var left_time = this.my_seat_product_list[i].left_time;
                                var time_type = this.my_seat_product_list[i].time_type;
                                var end_date = this.my_seat_product_list[i].use_end_datetime;
                                var date_time = this.my_seat_product_list[i].seat_purchase_history_id === seat_use_purchase_id ?
                                    this.timeToDateTime(left_time, time_type, end_date) : this.timeToDateTime(left_time, time_type, end_date);
                                this.my_seat_product_list[i].str_left_time = date_time;
                            } else {
                                // 기간권, 주/야간권인 경우
                                this.my_seat_product_list[i].click_yn = false;
                                var left_time = this.my_seat_product_list[i].left_time;
                                var time_type = this.my_seat_product_list[i].time_type;
                                var end_date = this.my_seat_product_list[i].use_end_datetime;
                                var date_time = '-';
                                this.my_seat_product_list[i].str_left_time = date_time;
                            }
                            if (this.my_seat_product_list[i].use_time_settings_yn == 0 && this.my_seat_product_list[i].seat_purchase_history_id == this.seat_purchase_history_id) {
                                this.my_seat_product_list[i].show_chk = true;
                            }
                            if (this.my_seat_product_list[i].day_count_yn == 0 && this.my_seat_product_list[i].hours_yn == 0 && this.my_seat_product_list[i].time_zone_yn == 1) {
                                // 주/야간권
                                //250612 주야간권 분단위까지 체크하도록 수정 
                                let start_times = this.my_seat_product_list[i].start_time.split(':');
                                let end_times = this.my_seat_product_list[i].end_time.split(':');
                                
                                let start_min = Number(start_times[0]) * 60 + Number(start_times[1]);
                                let end_min = Number(end_times[0]) * 60 + Number(end_times[1]);

                                let now = this.$moment();
                                let now_min = now.hours() * 60 + now.minutes();
                                
                                // 자정처리(00:00을 24:00으로 간주)
                                if (end_min === 0) {
                                    end_min = 24 * 60;
                                }
                                if(start_min < end_min){
                                    // 하루가 넘어가지 않는 조건
                                    if(start_min <= now_min && now_min < end_min ){
                                        this.my_seat_product_list[i].show_chk = false;
                                    }else{
                                        this.my_seat_product_list[i].show_chk = true;
                                    }
                                }else{
                                    // 하루가 넘어가는 조건
                                    if((start_min <= now_min && now_min < 1440) || (0 <= now_min && now_min < end_min)){
                                        this.my_seat_product_list[i].show_chk = false;
                                    }else{
                                        this.my_seat_product_list[i].show_chk = true;
                                    }
                                }
                                /*
                                var start_time = this.my_seat_product_list[i].start_time.split(':');
                                var end_time = this.my_seat_product_list[i].end_time.split(':');

                                var today = new Date();
                                var today_h = today.getHours();
                                var today_mm = today.getMinutes();
                                if (today_h >= Number(start_time[0]) && today_h < Number(end_time[0])) {
                                    this.my_seat_product_list[i].show_chk = false;
                                } else {
                                    this.my_seat_product_list[i].show_chk = true;
                                }
                                    */

                            }
                            if (this.my_seat_product_list[i].day_count_yn == 1 && this.my_seat_product_list[i].hours_yn == 0 && this.my_seat_product_list[i].time_zone_yn == 1) {
                                // 주/야간 기간권
                                //250612 주야간권 분단위까지 체크하도록 수정 
                                let start_times = this.my_seat_product_list[i].start_time.split(':');
                                let end_times = this.my_seat_product_list[i].end_time.split(':');

                                let start_min = Number(start_times[0]) * 60 + Number(start_times[1]);
                                let end_min = Number(end_times[0]) * 60 + Number(end_times[1]);

                                let now = this.$moment();
                                let now_min = now.hours() * 60 + now.minutes();
                                
                                // 자정처리(00:00을 24:00으로 간주)
                                if (end_min === 0) {
                                    end_min = 24 * 60;
                                }
                                if(start_min < end_min){
                                    // 하루가 넘어가지 않는 조건
                                    if(start_min <= now_min && now_min < end_min ){
                                        this.my_seat_product_list[i].show_chk = false;
                                    }else{
                                        this.my_seat_product_list[i].show_chk = true;
                                    }
                                }else{
                                    // 하루가 넘어가는 조건
                                    if((start_min <= now_min && now_min < 1440) || (0 <= now_min && now_min < end_min)){
                                        this.my_seat_product_list[i].show_chk = false;
                                    }else{
                                        this.my_seat_product_list[i].show_chk = true;
                                    }
                                }
                                /*
                                var start_time = this.my_seat_product_list[i].start_time.split(':');
                                var end_time = this.my_seat_product_list[i].end_time.split(':');

                                var today = new Date();
                                var today_h = today.getHours();
                                var today_mm = today.getMinutes();
                                if (today_h >= Number(start_time[0]) && today_h < Number(end_time[0])) {
                                    this.my_seat_product_list[i].show_chk = false;
                                } else {
                                    this.my_seat_product_list[i].show_chk = true;
                                }
                                */
                            }

                        }
                        for (let i = 0; i < my_seat_splice_arr.length; i++) {
                            this.my_seat_product_list.splice(my_seat_splice_arr[i], 1);
                        }
                        // exten_day_count;
                        // exten_left_time;
                        // exten_goods_group_name;
                        // exten_use_time_setting_yn;

                        this.my_coupon_list = responseList[1].data;
                        if (this.my_coupon_list != null && this.my_coupon_list.length != 0) {
                            for (var i = 0; i < this.my_coupon_list.length; i++) {
                                if (this.continue_seat_purchase_history_flag) { // 연장상품이 있다면 ,
                                    if (this.already_continue_seat_purchase_history_id == this.my_coupon_list[i].seat_purchase_history_id) { // 연장상품의 id와 내가가지고 있는 상품의 id가 같다면,
                                        this.useinfo_exten_seat_item_name = this.my_coupon_list[i].goods_group_name;
                                        if (this.my_coupon_list[i].use_time_settings_yn == 1) { // 시간사용설정 여부가 y 인 상품이라면,
                                            // 시간계산 로직 (해당 좌석의 종료시간에 맞추어 연장등록된 use hours plan 값을 이용해 예상종료시간을 계산)

                                            let time = new Date(this.seat_info[0].use_end_datetime).setMinutes(new Date(this.seat_info[0].use_end_datetime).getMinutes() + this.already_exten_seat_item_time);
                                            let tDate = new Date(time);

                                            let dd = tDate.getDate();
                                            let mm = tDate.getMonth() + 1; //January is 0!
                                            let yyyy = tDate.getFullYear();
                                            let hour = tDate.getHours();
                                            let min = tDate.getMinutes();
                                            if (hour < 10) {
                                                hour = '0' + hour;
                                            }
                                            if (min < 10) {
                                                min = '0' + min;
                                            }

                                            if (dd < 10) {
                                                dd = '0' + dd;
                                            }
                                            if (mm < 10) {
                                                mm = '0' + mm;
                                            }
                                            let currentTime = hour + ":" + min + "";
                                            this.useinfo_exten_seat_item_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
                                            var pic_time = this.already_exten_seat_item_time;
                                            if ((pic_time / 60) % 1 === 0) {
                                                this.useinfo_exten_seat_use_our_plan = (pic_time / 60) + '시간';
                                            } else {
                                                var min;
                                                min = pic_time % 60;
                                                pic_time = pic_time - min;
                                                this.useinfo_exten_seat_use_our_plan = (pic_time / 60) + '시간 ' + min + '분';
                                            }
                                        } else {
                                            let time;

                                            if (this.my_coupon_list[i].left_time > 0) {
                                                time = new Date(this.seat_info[0].use_end_datetime).setMinutes(new Date(this.seat_info[0].use_end_datetime).getMinutes() + this.my_coupon_list[i].left_time);
                                            } else {
                                                time = new Date(this.seat_info[0].use_end_datetime).setDate(new Date(this.seat_info[0].use_end_datetime).getDate() + this.my_coupon_list[i].end_day_count);
                                            }

                                            let tDate = new Date(time);
                                            let dd = tDate.getDate();
                                            let mm = tDate.getMonth() + 1; //January is 0!
                                            let yyyy = tDate.getFullYear();
                                            let hour = tDate.getHours();
                                            let min = tDate.getMinutes();
                                            if (hour < 10) {
                                                hour = '0' + hour;
                                            }
                                            if (min < 10) {
                                                min = '0' + min;
                                            }

                                            if (dd < 10) {
                                                dd = '0' + dd;
                                            }
                                            if (mm < 10) {
                                                mm = '0' + mm;
                                            }
                                            let currentTime = hour + ":" + min + "";
                                            this.useinfo_exten_seat_item_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
                                            if (this.already_exten_seat_item_time > 0) {
                                                var pic_time = this.already_exten_seat_item_time;
                                                if ((pic_time / 60) % 1 === 0) {
                                                    this.useinfo_exten_seat_use_our_plan = (pic_time / 60) + '시간';
                                                } else {
                                                    var min;
                                                    min = pic_time % 60;
                                                    pic_time = pic_time - min;
                                                    this.useinfo_exten_seat_use_our_plan = (pic_time / 60) + '시간 ' + min + '분';
                                                }
                                            } else {
                                                this.useinfo_exten_seat_use_our_plan = this.useinfo_exten_seat_item_time;
                                            }
                                        }
                                    }
                                }

                                if (val == 19 && (seat_use_purchase_id === this.my_coupon_list[i].seat_purchase_history_id) && this.my_coupon_list[i].use_time_settings_yn === 0 && this.extention_flag) {
                                    coupon_seat_splice_arr.push(i);
                                }
                                // 시간권인 경우
                                if (this.my_coupon_list[i].day_count_yn == 0 && this.my_coupon_list[i].hours_yn == 1 && this.my_coupon_list[i].time_zone_yn == 0) {
                                    var left_time = this.my_coupon_list[i].left_time;
                                    var time_type = this.my_coupon_list[i].time_type;
                                    var end_date = this.my_coupon_list[i].use_end_datetime;
                                    var date_time = this.my_coupon_list[i].seat_purchase_history_id === seat_use_purchase_id ?
                                        this.timeToDateTime(response.data.minute, time_type, end_date) : this.timeToDateTime(left_time, time_type, end_date);
                                    this.my_coupon_list[i].str_left_time = date_time;
                                    this.my_coupon_list[i].str_use_total_time = this.my_coupon_list[i].use_end_datetime;

                                    // 기간권, 주/야간권인 경우
                                } else {
                                    var left_time = this.my_coupon_list[i].left_time;
                                    var time_type = this.my_coupon_list[i].time_type;
                                    var end_date = this.my_coupon_list[i].use_end_datetime;
                                    var date_time = '-';
                                    this.my_coupon_list[i].str_left_time = date_time;
                                    this.my_coupon_list[i].str_use_total_time = this.my_coupon_list[i].use_end_datetime;
                                }
                                if (this.my_coupon_list[i].use_time_settings_yn == 0 && this.my_coupon_list[i].seat_purchase_history_id == this.seat_purchase_history_id) {
                                    this.my_coupon_list[i].show_chk = true;
                                }

                                if (this.my_coupon_list[i].day_count_yn == 0 && this.my_coupon_list[i].hours_yn == 0 && this.my_coupon_list[i].time_zone_yn == 1) {
                                    // 주/야간권
                                    //250612 주야간권 분단위까지 체크하도록 수정 
                                    let start_times = this.my_coupon_list[i].start_time.split(':');
                                    let end_times = this.my_coupon_list[i].end_time.split(':');

                                    let start_min = Number(start_times[0]) * 60 + Number(start_times[1]);
                                    let end_min = Number(end_times[0]) * 60 + Number(end_times[1]);

                                    let now = this.$moment();
                                    let now_min = now.hours() * 60 + now.minutes();
                                    
                                    // 자정처리(00:00을 24:00으로 간주)
                                    if (end_min === 0) {
                                        end_min = 24 * 60;
                                    }
                                    if(start_min < end_min){
                                        // 하루가 넘어가지 않는 조건
                                        if(start_min <= now_min && now_min < end_min ){
                                            this.my_coupon_list[i].show_chk = false;
                                        }else{
                                            this.my_coupon_list[i].show_chk = true;
                                        }
                                    }else{
                                        // 하루가 넘어가는 조건
                                        if((start_min <= now_min && now_min < 1440) || (0 <= now_min && now_min < end_min)){
                                            this.my_coupon_list[i].show_chk = false;
                                        }else{
                                            this.my_coupon_list[i].show_chk = true;
                                        }
                                    }
                                    /*
                                    var start_time = this.my_coupon_list[i].start_time.split(':');
                                    var end_time = this.my_coupon_list[i].end_time.split(':');

                                    var today = new Date();
                                    var today_h = today.getHours();
                                    var today_mm = today.getMinutes();
                                    if (today_h >= Number(start_time[0]) && today_h < Number(end_time[0])) {
                                        this.my_coupon_list[i].show_chk = false;
                                    } else {
                                        this.my_coupon_list[i].show_chk = true;
                                    }
                                    */
                                }
                                if (this.my_coupon_list[i].day_count_yn == 1 && this.my_coupon_list[i].hours_yn == 0 && this.my_coupon_list[i].time_zone_yn == 1) {
                                    // 주/야간 기간권
                                    // 250612 주야간권 분단위 체크 추가
                                    let start_times = this.my_coupon_list[i].start_time.split(':');
                                    let end_times = this.my_coupon_list[i].end_time.split(':');

                                    let start_min = Number(start_times[0]) * 60 + Number(start_times[1]);
                                    let end_min = Number(end_times[0]) * 60 + Number(end_times[1]);

                                    let now = this.$moment();
                                    let now_min = now.hours() * 60 + now.minutes();
                                    
                                    // 자정처리(00:00을 24:00으로 간주)
                                    if (end_min === 0) {
                                        end_min = 24 * 60;
                                    }
                                    if(start_min < end_min){
                                        // 하루가 넘어가지 않는 조건
                                        if(start_min <= now_min && now_min < end_min ){
                                            this.my_coupon_list[i].show_chk = false;
                                        }else{
                                            this.my_coupon_list[i].show_chk = true;
                                        }
                                    }else{
                                        // 하루가 넘어가는 조건
                                        if((start_min <= now_min && now_min < 1440) || (0 <= now_min && now_min < end_min)){
                                            this.my_coupon_list[i].show_chk = false;
                                        }else{
                                            this.my_coupon_list[i].show_chk = true;
                                        }
                                    }
                                    /*
                                    var start_time = this.my_coupon_list[i].start_time.split(':');
                                    var end_time = this.my_coupon_list[i].end_time.split(':');

                                    var today = new Date();
                                    var today_h = today.getHours();
                                    var today_mm = today.getMinutes();
                                    if (today_h >= Number(start_time[0]) && today_h < Number(end_time[0])) {
                                        this.my_coupon_list[i].show_chk = false;
                                    } else {
                                        this.my_coupon_list[i].show_chk = true;
                                    }
                                    */
                                }

                            }

                            for (let i = 0; i < coupon_seat_splice_arr.length; i++) {
                                this.my_coupon_list.splice(coupon_seat_splice_arr[i], 1);
                            }
                        }
                        // 기억
                        var from = this.$store.getters['getFrom_front'];
                        if (from.click == "move_seat") {
                            this.open_seatMap();
                        } else if (from.click == "end_seat") {
                            this.askFor_seat_use_end();
                        } else if (from.click == "use_extension") {
                            this.move_payment_seat_sub();
                        }

                    })
                }).catch(function (error) {
                    console.log('error=============>', error);
                });

            }
            // 내 사물함 클릭시 나오는 팝업
            if (val == 12) {
                this.locker_info = [];
                const locker_use_type = config.REQ_LOCKER_USE_GET;
                const data = {
                    data: {}
                };
                // /kiosk/locker/use/get
                this.$store.dispatch(locker_use_type.action_name, {
                    type: locker_use_type,
                    data: data
                }).then(response => {
                  this.locker_info = JSON.parse(JSON.stringify(this.$store.getters['get_select_locker']));
                  let current_locker_idx = -1;
                    for (let i = 0; i <response.data.length; i++){
                        this.locker_info.locker_id == response.data[i].locker_id;
                        current_locker_idx = i;
                        break;
                    }
                  let use_day_count = response.data[current_locker_idx].use_day_count;
                    if (response.data[current_locker_idx].continue_locker_purchase_history_id != null) {
                        this.exten_locker_flag = true;
                        const locker_info_type = config.REQ_LOCKER_GOODS_GET;
                        const data_info = {
                            data: {
                                'locker_purchase_history_id': response.data[current_locker_idx].continue_locker_purchase_history_id
                            }
                        };

                        this.$store.dispatch(locker_use_type.action_name, {
                            type: locker_info_type,
                            data: data_info
                        }).then(response => {
                            this.locker_info = JSON.parse(JSON.stringify(this.$store.getters['get_select_locker']));
                            /*
                            var product_st = this.locker_info.locker.start_datetime;
                            var product_end = this.locker_info.locker.end_datetime;
                            var sdt = new Date(product_st);
                            var edt = new Date(product_end);
                            var dateDiff = Math.ceil((edt.getTime() - sdt.getTime()) / (1000 * 3600 * 24));

                            this.locker_info.locker.product_day = Number(dateDiff) + '일 + 추가연장' + Number(response.data[0].left_date);

                            let time = new Date(this.locker_info.locker.end_datetime).setDate(new Date(this.locker_info.locker.end_datetime).getDate() + Number(response.data[0].left_date));

                            let tDate = new Date(time);
                            let dd = tDate.getDate();
                            let mm = tDate.getMonth() + 1; //January is 0!
                            let yyyy = tDate.getFullYear();
                            let hour = tDate.getHours();
                            let min = tDate.getMinutes();
                            let sec = sdt.getSeconds();

                            if (hour < 10) {
                                hour = '0' + hour;
                            }
                            if (min < 10) {
                                min = '0' + min;
                            }
                            if (dd < 10) {
                                dd = '0' + dd;
                            }
                            if (mm < 10) {
                                mm = '0' + mm;
                            }
                            if (sec < 10) {
                                sec = '0' + sec;
                            }
                            let currentTime = hour + ":" + min + ":" + sec;
                            let cal_date = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;

                            this.locker_info.locker.end_datetime = cal_date;
                            */
                            var product_st = this.locker_info.locker.start_datetime;
                            var product_end = this.locker_info.locker.end_datetime;
                            //var use_day_count = this.locker_info.locker.use_day_count; // 사물함 상품 기간
                            this.locker_info.locker.product_day = use_day_count + '일 + 추가연장' + Number(response.data[0].left_date);
                            let time = this.$moment(product_end, "YYYY-MM-DD HH:mm:00");
                            this.$moment(time).add(response.data[0].left_date, 'days')
                            this.locker_info.locker.end_datetime = this.$moment(time).format('YYYY-MM-DD hh:mm:00');

                        }).catch(function (error) {
                            console.log('error=============>', error);
                        });
                    } else {
                        // this.locker_info = [];
                        this.exten_locker_flag = false;
                        this.locker_info = JSON.parse(JSON.stringify(this.$store.getters['get_select_locker']));
                        /*
                        var product_st = this.locker_info.locker.start_datetime;
                        var product_end = this.locker_info.locker.end_datetime;
                        var sdt = new Date(product_st);
                        var edt = new Date(product_end);
                        var dateDiff = Math.ceil((edt.getTime() - sdt.getTime()) / (1000 * 3600 * 24));
                        this.locker_info.locker.product_day = dateDiff;
                         */
                        var product_st = this.locker_info.locker.start_datetime;
                        var product_end = this.locker_info.locker.end_datetime;
                        //var use_day_count = response.data[current_locker_idx].use_day_count;
                        this.locker_info.locker.product_day = response.data[current_locker_idx].use_day_count;


                    }

                }).catch(function (error) {
                    console.log('error=============>', error);
                });

            }
            if (val == 13) {
                var locker_info = this.$store.getters['get_main_page_update_locker'];
                if (locker_info != null) {
                    this.move_locker_id = locker_info.sel_locker_id;
                    this.move_locker_name = locker_info.sel_locker_name;
                    // 스토어에서 가져온 my seat use id 를 저장함
                    this.sel_locker_use_id = locker_info.my_locker_use_id;
                    this.sel_locker_id = locker_info.my_locker_id;
                }
            }
            if (val == 15) {
                //그룹룸 정보
                var groom = this.$store.getters['get_select_groom'];

                // 그룹룸 로직 상품 추가
                const type = config.REQ_GROOM_USE_SELECT;
                var user_data = this.$store.getters['getUser'];

                const data = {
                    'user_id': user_data.user_id,
                    'groom_id': groom[0].groom_id
                };

                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    this.groom_info = response.data;
                }).catch(function (error) {
                    console.log('error=============>', error);
                });

                // 그룹룸 사용정보 호출
                const use_check = config.REQ_GROOM_USE_CHECK;
                const sel_groom_data = {};
                sel_groom_data.groom_id = groom[0].groom_id;

                this.$store.dispatch(use_check.action_name, {
                    type: use_check,
                    data: sel_groom_data
                }).then(response => {
                    if (response.data.length > 0) {
                        for (let i = 0; i < response.data.length; i++) {
                            if (groom[0].groom_id == response.data[i].groom_id) {
                                if (response.data[i].continue_yn == 1) {
                                    this.extention_groom_flag = true;
                                    const reser_check = config.REQ_GROOM_TODAY_RESERVATION_GET_LIST

                                    this.$store.dispatch(reser_check.action_name, {
                                        type: reser_check,
                                        data: {
                                            'groom_id': groom[0].groom_id
                                        }

                                    }).then(response => {
                                        for (let i = 0; i < response.data.length; i++) {
                                            if (response.data[i].use_start_datetime == this.groom_info[0].use_end_datetime) {
                                                // this.groom_info[0].use_end_datetime = response.data[i].use_end_datetime;
                                                this.exten_groom_use_end_datetime = response.data[i].end_datetime;

                                            }
                                        }

                                    }).catch(function (error) {
                                        console.log('error=============>', error);
                                    });

                                } else {
                                    this.extention_groom_flag = false;
                                }
                                if(response.data[i].groom_reservation_id){
                                    this.reservation_groom_flag = true; 
                                }
                            }

                        }
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });

                // 내 그룹룸 상품목록
                const type2 = config.REQ_MYPAGE_GROOM_TYPE_GOODS_GET_LIST;
                var user_data = this.$store.getters['getUser'];
                var get_groom_info = this.$store.getters['get_select_groom'];
                const data2 = {
                    'user_id': user_data.user_id,
                    'groom_type_id': get_groom_info[0].groom_type_id
                };
                this.$store.dispatch(type.action_name, {
                    type: type2,
                    data: data2
                }).then(response => {
                    this.my_groom_product_list = response.data;
                    if (this.my_groom_product_list != null && this.my_groom_product_list.length != 0) {

                        for (let i = 0; i < this.my_groom_product_list.length; i++) {

                            var left_time = this.my_groom_product_list[i].left_hours;
                            var end_date = this.my_groom_product_list[i].use_end_datetime;
                            var date_time = this.timeToDateTime(left_time, "시간", end_date);
                            this.my_groom_product_list[i].str_left_time = date_time;

                            let value = '';
                            var hour = Math.floor(this.my_groom_product_list[i].use_hours / 60);
                            var min = Math.floor(this.my_groom_product_list[i].use_hours % 60);
                            if (min > 0) {
                                value = hour + '시간' + min + '분';
                            } else {
                                value = hour + '시간';
                            }
                            this.my_groom_product_list[i].goods_time = value;
                            this.my_groom_product_list[i].groom_id = get_groom_info[0].groom_id;
                        }
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });

            }

            if (val == 18) {
                this.extention_data = this.$store.getters['getExtention_data'];
                if (this.extention_data[0].end_date == null) {
                    var str_goods_time = this.extention_data[0].goods_time;
                    var goods_time_parser = str_goods_time.split('일');
                    // var str_date = this.$store.getters['get_str_datetime'];
                    var str_date = this.$moment().format("YYYY-MM-DD HH:mm:00");
                    var tDate = new Date(str_date);
                    // 날짜(일) 더하기
                    tDate.setDate(tDate.getDate() + Number(goods_time_parser[0]));
                    var dd = tDate.getDate();
                    var mm = tDate.getMonth() + 1; //January is 0!
                    var yyyy = tDate.getFullYear();
                    var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
                    var h = tDate.getHours();
                    var m = tDate.getMinutes();
                    if (h < 10) {
                        h = '0' + h;
                    }
                    if (m < 10) {
                        m = '0' + m;
                    }
                    var currentTime_server = h + ':' + m + ':' + '00';
                    if (dd < 10) {
                        dd = '0' + dd;
                    }

                    if (mm < 10) {
                        mm = '0' + mm;
                    }
                    var end_date_for_server = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;
                    this.extention_data[0].end_date = end_date_for_server;
                }

            }
            if (val == 20) {
                var user_data = this.$store.getters['getUser'];
                var get_groom_info = this.$store.getters['get_select_groom'];

                const groom_use_type = config.REQ_GROOM_USE_CHECK;
                const groom_use_data = {};
                this.$store.dispatch(groom_use_type.action_name, {
                    type: groom_use_type,
                    data: groom_use_data
                }).then(response => {
                    this.exten_groom_data = response.data;

                }).catch(function (error) {
                    console.log('error=============>', error);
                });

                // 내 그룹룸 상품목록
                const type = config.REQ_MYPAGE_GROOM_TYPE_GOODS_GET_LIST;

                const data = {
                    'user_id': user_data.user_id,
                    'groom_type_id': get_groom_info[0].groom_type_id
                };
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    this.my_groom_product_list = response.data;
                    if (this.my_groom_product_list != null && this.my_groom_product_list.length != 0) {
                        for (let i = 0; i < this.my_groom_product_list.length; i++) {
                            let value = '';
                            let value2 = '';
                            var hour = Math.floor(this.my_groom_product_list[i].use_hours / 60);
                            var min = Math.floor(this.my_groom_product_list[i].use_hours % 60);
                            var hour2 = Math.floor(this.my_groom_product_list[i].left_hours / 60);
                            var min2 = Math.floor(this.my_groom_product_list[i].left_hours % 60);
                            if (min > 0) {
                                value = hour + '시간' + min + '분';
                            } else {
                                if (this.my_groom_product_list[i].end_day_count === null) {
                                    value = hour + '시간'
                                } else {
                                    value = hour + '시간/' + this.my_groom_product_list[i].end_day_count + '일';
                                }
                            }
                            if (min2 > 0) {
                                value2 = hour2 + '시간' + min2 + '분';
                            } else {
                                value2 = hour2 + '시간'
                            }
                            this.my_groom_product_list[i].goods_time = value;
                            this.my_groom_product_list[i].str_left_time = value2;
                            this.my_groom_product_list[i].groom_id = get_groom_info[0].groom_id;
                            this.my_groom_product_list[i].show_on = false;
                            if (this.my_groom_product_list[i].selection_plan_code == null) { // 시간충전권만 내 그룹룸 상품 목록에서 보여주기
                                this.my_groom_product_list[i].show_on = true;
                            }
                        }
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }

            if (val == 25) {
                const type = config.REQ_OUT_SOON;
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: {}
                }).then(response => {
                    this.out_soon_list = response.data

                }).catch(function (error) {
                    console.log('error=============>', error);
                });

            }

        },
        get_tab_kind() { 
            // 이용안내 팝업 탭용 
            let tab_list = document.querySelectorAll('.tab-kind');
            tab_list.forEach(e => {
                e.classList.remove('active');
            })
            tab_list[this.tab_kind].classList.add('active');
        },
    },

}
</script>

<style>
.alert-layer {
    position: absolute;
    left: 40%;
    z-index: 99999;
}

.alert-layer_seat {
    position: absolute;
    left: 40%;
    z-index: 99999;
}

.w100 {
    width: 100%;
}
.alert-body-sub {
    text-align: center;
}
.alert-body-sub span {
    font-size: 1rem;
    /* margin-bottom: 40px; */
    padding: 0 0 1.3rem;
    line-height: 1.8rem;
}
.guide-info-body-using {
    max-height: 50vh;
    /* padding: 5%; */
    padding: 1.5rem 1rem 0;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/components/pop.vue